/* eslint-disable camelcase */
import * as React from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItemButton,
  MenuItem,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
  useTheme
} from '@mui/material';
import MuiPagination from '@mui/material/Pagination';
import {
  Download,
  ExpandLessOutlined,
  ExpandMoreOutlined,
  Preview,
  Print
} from '@mui/icons-material';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {useNavigate, useLocation, useParams} from 'react-router-dom';
import {
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridPagination,
  GridEventListener,
  GridRowId,
  GridCellParams
} from '@mui/x-data-grid-premium';
import {environment} from '@shared/config/environment';
import FormConstants from '@shared/constants/FormConstants';
import DataGridComponent from '@components/datagrid/DataGridComponent';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {
  ColumnDataGridComponentDiv,
  DetailPanelDiv,
  PaginationStyle,
  RowsCountDivStyle,
  TablePaginationWrapper,
  RenderTabsDiv,
  RenderTabsContentDiv,
  DetailPanelContentDiv,
  RenderMainSectionDiv,
  RenderListDiv,
  RenderListUL,
  RenderListLI,
  DataGridToolTipTypography
} from './CollapsibleTableStyle';
import SubTabsComponent from '@components/subTabs/subTabs';
import CardComponent from '@components/card/CardComponent';
import HelperUtils from '@shared/utils/HelperUtils';
import AuthUtils from 'src/utils/AuthUtils';
import {APP} from 'src/styles/variables';
import {useTranslation} from 'react-i18next';
import EncryptUtils from 'src/utils/EncryptUtils';
import {
  createAuditLog,
  editPurgeAndLegalHold,
  getPageData,
  getReportsFileExportData,
  getClaimPreviewPdf,
  getPrintedClaim,
  getTextClaim,
  getStatementPdfPA,
  permissionsCheck
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useSnackbar} from 'notistack';
import DocumentsComponent from '@components/documents/DocumentsComponent';
import moment from 'moment';
import TaskCardComponent from '@components/Taskcards/TaskcardComponent';
import {useAppContext} from '@context/AppContext';
import {LoadingButton} from '@mui/lab';
import EmptyContent from '@components/empty-content/empty-content';
import {
  BASE_DATA_GRID_ROW,
  BASE_DEMOGRAPHIC_ID,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_PROCEDURE_ID,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_SUB_MODULE,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  BASE_UNIQUE_ID,
  INVOICE_NUMBER,
  IS_FROM_EPIC,
  IS_FROM_ATHENA,
  MODE,
  PARAMS_KEY,
  CHILD_TAB_NAME,
  ASSET_INFO_ID,
  BASE_ACCESSION_NUMBER
} from 'src/routes/BaseRoute';
import {useBannerDetails} from '@context/BannerContext';
import {useModuleContext} from '@context/ModuleContext';
import PeriodontalChartComponent from '@components/periodontal-chart/PeriodontalChartComponent';
import ClaimViewer from '@components/docViewer/CustomViewers/ClaimViewer/ClaimViewer';
import {dialog} from 'src/theme/overrides/components/dialog';
import ActionModalDialog from '@components/dialog/action-dialog/ActionModalDialog';
import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import {useRefreshLeftMenu} from '@context/RefreshLeftMenuContext';
import VitalsComponent from '@components/vitals/VitalsComponent';
import {Controller, useForm} from 'react-hook-form';
import BasicDatePicker from '@components/form/date-picker/BasicDatePicker';
import dayjs from 'dayjs';
import HighDetailStatement from '../../modules-menu/patient-accounting/HighDetailStatement';
import { useState } from 'react';

interface CollapsibleTableProps {
  setRefreshFilter?: any;
  refreshFilter?: any;
  sectionUIData: any;
  sectionRowsData: any;
  onRowClick?: any;
  module?: any;
  sub_module?: any;
  selectedRowDetails?: any;
  recordId?: any;
  handleCheckBoxClick?: any;
  filteredcheckData?: any;
  clearSelectedDataCount?: any;
  isFromModules?: boolean;
  rowsCount?: number;
  searchFormFieldsData?: any;
  setSelectedReportsData?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  handleDisableCheckBox?: boolean;
  legacyApp?: string;
  BenefitsPayload?: any;
  isReportsButtonLoader?: boolean;
  onCellClick?: any;
  ParentLegacyValue?: string;
  handleDeleteLegalHold?: (data: any) => void;
  handleEditUser?: (data: any) => void;
  handleDeleteUser?: (data: any) => void;
  // eslint-disable-next-line react/boolean-prop-naming
  apiLoader?: boolean;
  growthChartType?: string;
  gridHeight?: string | undefined;
  // eslint-disable-next-line react/boolean-prop-naming
  hideFooter?: boolean;
  // eslint-disable-next-line react/boolean-prop-naming
  loading?: boolean;
  setState?: React.Dispatch<any>;
  procedure_type?: string;
  accession_number?: string;
  specimen_number?: any;
  specimen_number_id?: any;
  specimen_type?: any;
  procedure_id?: any;
  demographic_id?: any;
  limit?: number;
  offset?: number;
  // eslint-disable-next-line react/boolean-prop-naming
  opening?: boolean;
  setopening?: React.Dispatch<any>;
  radiochangevalue?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  deleteDocument?: boolean;
  setDeleteDocument?: React.Dispatch<any>;
  handleAcceptButtonClick?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  disableToolbar?: boolean;
  onSortModelChange?: any;
  onGridFiltersChange?: any;
  isRowSelectable?: any;
  rowCount?: any;
  paginationModel?: any;
  onPaginationModelChange?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  displayHorizontalScroll?: boolean;
  sx?: any;
  checkboxColor?: string;
  handleOnSelectionModelChange?: any;
  forceHideFooter?: any;
  minHeight?: any;
  handleViewButtonClick?: any;
  handleBooleanCheckboxChange?: any;
  processRowUpdate?: any;
  pinnedRowsData?: any;
  expandedRowIds?: any;
  setExpandedRowIds?: (value: any) => void;
  setSyncUsers?: (value: boolean) => void;
  usersync?: boolean;
  tableRefresh?: boolean;
  setTableRefresh?: (value: boolean) => void;
}

const FILTER_OPERATORS_WITHOUT_VALUE = ['isEmpty', 'isNotEmpty'];

const sanitizeGridFilters = (gridFilters?: any) => {
  if (!gridFilters || !Array.isArray(gridFilters.items)) {
    return gridFilters;
  }

  return {
    ...gridFilters,
    items: gridFilters.items
      .map((item: any) => {
        if (!item?.field || !item?.operator) {
          return null;
        }

        if (FILTER_OPERATORS_WITHOUT_VALUE.includes(item.operator)) {
          const updatedItem = {...item};
          delete updatedItem.value;
          return updatedItem;
        }

        if (Array.isArray(item.value)) {
          return {
            ...item,
            value: item.value.filter(
              (value: any) => value !== undefined && value !== null && `${value}`.trim() !== ''
            )
          };
        }

        return item;
      })
      .filter(Boolean)
  };
};

const CollapsibleTable = (props: CollapsibleTableProps): any => {
  const theme = useTheme();
  const {
    appState: {applicationName}
  } = useAppContext();

  const {
    sectionUIData,
    sectionRowsData: rowsData,
    onRowClick,
    handleCheckBoxClick,
    filteredcheckData,
    setSelectedReportsData,
    clearSelectedDataCount = 0,
    rowsCount,
    searchFormFieldsData,
    handleDisableCheckBox = false,
    BenefitsPayload,
    isReportsButtonLoader,
    onCellClick,
    handleDeleteLegalHold,
    handleEditUser,
    handleDeleteUser,
    apiLoader,
    growthChartType,
    procedure_type,
    accession_number,
    specimen_number,
    procedure_id,
    specimen_number_id,
    specimen_type,
    limit,
    offset,
    opening,
    radiochangevalue,
    deleteDocument,
    setDeleteDocument,
    setopening,
    pinnedRowsData,
    setSyncUsers,
    usersync
  } = props;

  const {globalSearchConfig} = environment;
  const enableGridSearch = globalSearchConfig?.enableGridSearch;
  const columnData = sectionUIData?.fields;
  const [showDialog, setShowDialogOpen] = React.useState(false);
  const [activeAction, setActiveAction] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const {refreshLeftMenu, setRefreshLeftMenu} = useRefreshLeftMenu();
  const [tabsSubSecData, setTabsSubSecData] = React.useState<any>({});
  const [currentTab, setCurrentTab] = React.useState<{[key: string]: string}>(
    {}
  );
  const [mainColumns, setMainColumns] = React.useState<any>([]);
  const [rowsCountData, setRowsCountData] = React.useState(0);
  const [rowsPAData, setRowsPAData] = React.useState<any>('');
  const [selectedRowIds, setSelectedRowIds] = React.useState<any>([]);
  const [selectedData, setSelectedData] = React.useState<any>([]);
  const getLocaleStorageData = AuthUtils.getSelectedCheckBoxData();
  const getAdditionalLocaleStorageData =
    AuthUtils.getSelectedAdditionalCheckBoxData();
  const getPatientAccountinglocaleStorageData =
    AuthUtils.getSelectedPatientAccountingCheckBoxData();

  const [isEnabled, setIsEnabled] = React.useState(false);
  const [pageizeCount, setpagesizecount] = React.useState(0);
  const [totalPagesize, settotalPagesize] = React.useState(0);
  const [totalPagesizevalue, settotalPagesizevalue] = React.useState(0);
  const [gridHeight] = React.useState('100%');
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const [excelloading, setExportExcelLoading] = React.useState(false);
  const [csvloading, setExportCSVLoading] = React.useState(false);
  const [pdfloading, setExportPDFLoading] = React.useState(false);
  const [gridFilters, setGridFilters] = React.useState<any>([]);

  const [yearTrue, setYearTrue] = React.useState(false);
  const [sortModel, setSortModel]: any = React.useState([]);
  const [radiochangedata, setRadiochangevalue] = React.useState('');
  const [datagridOffset, setDataGridOffset] = React.useState(0);
  const [datagridlimit, setDataGridlimit] = React.useState(25);
  const params: any = useParams();
  const {bannerDetails} = useBannerDetails();
  const {moduleState} = useModuleContext();
  const {isBH, isBHReason}: any = moduleState;
  const [dialogLoader, setDialogLoader] = React.useState<boolean>(false);
  const [openDialog, setOpenDialog] = React.useState({
    viewDialog: false
  });
  const [dialogInfo, setDialogInfo] = React.useState<any>({
    dialogDescription: ''
  });
  const [selectName, setSelectName] = React.useState<any>({
    legacy_system: '',
    flowsheet_group: '',
    FlowsheetGroup: '',
    legacy_group: '',
    LegacyAppGroup: '',
    user_id: '',
    ID: '',
    start_date: '',
    stop_date: ''
  });

  const [permissionsResponse, setPermissionsResponse] = React.useState<any>(null); 

 React.useEffect(() => {

    const fetchPermissions = async () => {
      try {
        if (props?.module === 'patient-accounting' && props?.sub_module === 'accounts') {
          const payload = {};
          const encryptedPayload = EncryptUtils.encryptedData(payload);
          const response = await permissionsCheck(
            applicationName,
            props.module,
            {tk: encryptedPayload},
            'checkPermissions'
          );
          // console.log('Permissions Response:', response);
          setPermissionsResponse(response);
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
    };
    fetchPermissions();

  }, []); 
  let generate_statement = permissionsResponse?.data?.some((p: any) => p?.function === 'generate_statement' ) || false;

  const [isFormDirty, setIsFormDirty] = React.useState(false);
  const [isFormdateDirty, setIsFormDateDirty] = React.useState(false);
  const [isStartDateGreater, setIsStartDateGreater] = React.useState(false);
  const [selectSectionState, setSelectSectionState] = React.useState<{
    [key: string]: {
      showGrid: boolean;
      refreshKey: number;
      start_date?: string | null;
      stop_date?: string | null;
    };
  }>({});

  const methods = useForm<Record<string, any>>({});

  const {
    control,
    watch,
    setError,
    clearErrors,
    setValue,
    reset,
    resetField,
    formState: {errors}
  } = methods;

  const dialogClose = () => {
    setOpenDialog(() => ({
      viewDialog: false
    }));

    setDialogLoader(false);
  };

  const handleDataForCustomToolbar = (
    gridFilters?: any,
    yearTrue?: any,
    sortModel?: any,
    offset?: any,
    limit?: any
  ) => {
    const normalizedGridFilters = sanitizeGridFilters(gridFilters);

    if (gridFilters) {
      setGridFilters(normalizedGridFilters);

      if (
        rowsPAData &&
        rowsPAData[0] &&
        rowsPAData[0]?.SaveRecords &&
        rowsPAData[0]?.SaveRecords === 'true' &&
        localStorage.getItem('PATabledata')
      ) {
        const values = localStorage.getItem('PATabledata');
        if (values !== null) {
          try {
            const parsedData = JSON.parse(values);
            const updatedData = {
              ...parsedData,
              gridFilters: normalizedGridFilters
            };

            localStorage.setItem('PATabledata', JSON.stringify(updatedData));
          } catch (error) {
            console.error(
              'Failed to parse PATabledata from localStorage:',
              error
            );
          }
        }
      }
    }
    if (yearTrue) {
      setYearTrue(yearTrue);
      if (
        rowsPAData &&
        rowsPAData[0] &&
        rowsPAData[0]?.SaveRecords &&
        rowsPAData[0]?.SaveRecords === 'true' &&
        localStorage.getItem('PATabledata')
      ) {
        const values = localStorage.getItem('PATabledata');
        if (values) {
          const existing = localStorage.getItem('PATabledata');
          const base = existing ? JSON.parse(existing) : {};
          localStorage.setItem(
            'PATabledata',
            JSON.stringify({
              ...base,
              yearTrue: yearTrue
            })
          );
        }
      }
    }
    if (sortModel) {
      setSortModel(sortModel);
      if (
        rowsPAData &&
        rowsPAData[0] &&
        rowsPAData[0]?.SaveRecords &&
        rowsPAData[0]?.SaveRecords === 'true' &&
        localStorage.getItem('PATabledata')
      ) {
        const values = localStorage.getItem('PATabledata');
        if (values) {
          const existing = localStorage.getItem('PATabledata');
          const base = existing ? JSON.parse(existing) : {};
          localStorage.setItem(
            'PATabledata',
            JSON.stringify({
              ...base,
              sortModel: sortModel
            })
          );
        }
      }
    }
    if (offset) {
      setDataGridOffset(offset);
    }
    if (limit) {
      setDataGridlimit(limit);
    }
  };
  // React.useEffect(() => {
  //   if (rowsCount) {
  //     setRowsCountData(rowsCount);
  //   }
  // }, [rowsCount]);

  const handleIsEnabled = async (data: string, id: number) => {
    const is_enabled = data === 'No' ? '1' : data === 'Yes' ? '0' : data;
    const payload: any = {is_enabled};

    payload.row_id = id;
    payload.action = FormConstants.PURGE_TERMS.PURGE_UPDATE;
    payload.sql_data = sectionUIData?.update_is_enable_sql;
    try {
      setIsEnabled(true);
      const encryptRequestData = EncryptUtils.encryptedData(payload);
      await editPurgeAndLegalHold({tk: encryptRequestData});
      setIsEnabled(false);
    } catch (error) {
      setIsEnabled(false);
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const handleIsEnableds = async (e: any, data: string, id: number) => {
    e.preventDefault();
    // const is_enabled = data === 'No' ? '1' : data === 'Yes' ? '0' : data;
    // const payload: any = {is_enabled};

    // payload.row_id = id;
    // payload.action = FormConstants.PURGE_TERMS.PURGE_UPDATE;
    // payload.sql_data = sectionUIData?.update_is_enable_sql;
    // try {
    //   setIsEnabled(true);
    //   const encryptRequestData = EncryptUtils.encryptedData(payload);
    //   await editPurgeAndLegalHold({tk: encryptRequestData});
    //   setIsEnabled(false);
    // } catch (error) {
    //   setIsEnabled(false);
    //   const errMessage = getErrorMessage(error);
    //   enqueueSnackbar(errMessage, SnackBarConfig.getError());
    // }
  };

  const deleteLegalHold = (data: any): void => {
    if (handleDeleteLegalHold && typeof handleDeleteLegalHold === 'function') {
      handleDeleteLegalHold(data);
    }
  };

  const editUser = (data: any): void => {
    if (handleEditUser && typeof handleEditUser === 'function') {
      handleEditUser(data);
    }
  };

  const DeleteUser = (data: any) => {
    if (handleDeleteUser && typeof handleDeleteUser === 'function') {
      handleDeleteUser(data);
    }
  };

  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const legacyApp = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_LEGACY_APP
  );

  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );

  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );

  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );

  const mode = EncryptUtils.getDecryptedData(location?.search, MODE);

  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);

  const specimenNumber = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER
  );

  const specimenNumberId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER_ID
  );
  const accessionNumber = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_ACCESSION_NUMBER
  );
  const specimenType = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_TYPE
  );

  const onChange = (to: string, data?: any) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: recordId,
      [BASE_LEGACY_APP]: props?.legacyApp || legacyApp,
      [BASE_UNIQUE_ID]: uniqueId,
      [IS_FROM_EPIC]: isFromEpic,
      [IS_FROM_ATHENA]: isFromAthena,
      [MODE]: mode,
      [BASE_SPECIMEN_NUMBER]:
        data?.SpecimenNumber || specimen_number || specimenNumber,
      [BASE_SPECIMEN_NUMBER_ID]:
        data?.ID || specimen_number_id || specimenNumberId,
      [BASE_ACCESSION_NUMBER]: data?.AccessionNumber || accessionNumber,
      [BASE_SPECIMEN_TYPE]: data?.SpecimenType || specimen_type || specimenType,
      [BASE_DATA_GRID_ROW]: JSON.stringify(data)
    });

    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}/${to}?${PARAMS_KEY}=${paramsKey}`;

    if (menuItem) {
      url += `&${BASE_MENU_ITEM}=${menuItem}`;
    }

    navigate(url, {state: {rowData: data}});
    if (props?.module === 'lis' && data?.SpecimenNumber) {
      setRefreshLeftMenu(true);
    }
  };

  const handleCellClicked = (params: any, items: any) => {
    for (const field of items.fields) {
      if (
        params?.field === field.data_column &&
        field?.is_clickable &&
        field?.move_to_end &&
        params?.value !== null &&
        params?.value !== undefined &&
        params?.value !== '' &&
        (!('ClinicalEncounterId' in (params?.row || {})) || // If not present, allow
          params?.row?.ClinicalEncounterId != null) // If present, must not be null
      ) {
        // AuthUtils.setAuditIdentifier(params?.value);
        // AuthUtils.setAuditIdentifierType(params?.colDef?.headerName);
        // AuthUtils.setAuditLegacyApp(params?.row?.LegacyApp);
        const paramsKey = EncryptUtils.setEncryptedParams({
          [BASE_DEMOGRAPHIC_ID]: params?.row?.DemographicID,
          [BASE_PROCEDURE_ID]: params?.row?.ProcedureID,
          [BASE_RECORD_ID]: recordId,
          [BASE_LEGACY_APP]: props?.legacyApp || legacyApp,
          [BASE_UNIQUE_ID]: uniqueId,
          [IS_FROM_EPIC]: isFromEpic,
          [IS_FROM_ATHENA]: isFromAthena,
          [MODE]: mode,
          [BASE_SPECIMEN_NUMBER]: specimen_number || specimenNumber,
          [BASE_SPECIMEN_NUMBER_ID]: specimen_number_id || specimenNumberId,
          [BASE_ACCESSION_NUMBER]: accessionNumber,
          [BASE_SPECIMEN_TYPE]: specimen_type || specimenType,
          [INVOICE_NUMBER]: params?.row?.InvoiceNumber,
          [CHILD_TAB_NAME]: field?.child_subpath,
          [ASSET_INFO_ID]: params?.row?.AssetInfoID
        });
        let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${field?.move_to_module || props?.module}/${BASE_ROUTE_SUB_MODULE}/${field.parent_path}?${PARAMS_KEY}=${paramsKey}`;
        if (menuItem) {
          url += `&${BASE_MENU_ITEM}=${menuItem}`;
        }
        if (field?.move_to_module) {
          // AuthUtils.setPatientAccountingSelectedCheckBoxList(
          //   getLocaleStorageData
          // );
          if (handleCheckBoxClick)
            handleCheckBoxClick([params.row], [params.id]);
          AuthUtils.setSelectedAdditionalCheckBoxData(
            JSON.stringify([params.row])
          );
          AuthUtils.setSelectedAdditionalCheckBoxList([params.id]);

          AuthUtils.setSelectedPatientAccountingCheckBoxData(
            JSON.stringify({
              ...params.row,
              offset: datagridOffset,
              limit: datagridlimit,
              gridFilters: gridFilters,
              yearTrue: yearTrue,
              sortModel: sortModel
            })
          );
          // AuthUtils.setSelectedAdditionalCheckBoxData
          localStorage.setItem('Patient_encounter_number_fetched', 'false');
          localStorage.setItem('patient_encounterData_removed', 'false');
        }
        navigate(url);
      }
    }
  };

  const renderDeleteButton = (data: any, item: any): React.ReactElement => {
    let buttonDisableStatus = false;
    if (item.disable && item.disable.key && item.disable.in) {
      buttonDisableStatus = item.disable.in.includes(
        data.row[item.disable.key]
      );
    }
    return (
      <LoadingButton
        disabled={buttonDisableStatus}
        type="submit"
        variant="contained"
        onClick={() => deleteLegalHold(data)}
        sx={{
          height: '1.8rem',
          width: '5rem',
          backgroundColor: theme.palette.primary.lighter
          // fontWeight: 'normal',
          // backgroundColor: APP.PALETTE.SUB_MODULE_COLOR.BUTTON,
          // '&:hover': {
          //   backgroundColor: `${APP.PALETTE.SUB_MODULE_COLOR.HOVER_BUTTON}`,
          //   color: `${APP.PALETTE.PRIMARY.CONTRAST_TEXT}`
          // },
          // color: APP.PALETTE.PRIMARY.CONTRAST_TEXT
        }}>
        {t('PRIVATE.PURGE.DELETE', {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderIsEnableButton = (data: any, id: number) => {
    return (
      <LoadingButton
        type="submit"
        variant="contained"
        onClick={() => handleIsEnabled(data, id)}
        sx={{
          height: '1.8rem',
          width: '5rem',
          backgroundColor:
            data === FormConstants.BOOLEAN_TYPES.YES || data === true
              ? theme.palette.grey[500]
              : theme.palette.primary.dark
          // fontWeight: 'normal',
          // backgroundColor:
          //   data === FormConstants.BOOLEAN_TYPES.YES || data === true
          //     ? `${APP.PALETTE.SUB_MODULE_COLOR.DISABLED_GRAY}`
          //     : `${APP.PALETTE.SUB_MODULE_COLOR.BUTTON}`,
          // '&:hover': {
          //   backgroundColor: `${APP.PALETTE.SUB_MODULE_COLOR.HOVER_BUTTON}`,
          //   color: `${APP.PALETTE.PRIMARY.CONTRAST_TEXT}`
          // },
          // color:
          //   data === FormConstants.BOOLEAN_TYPES.YES || data === true
          //     ? `${APP.PALETTE.SUB_MODULE_COLOR.BLACK}`
          //     : `${APP.PALETTE.PRIMARY.CONTRAST_TEXT}`
        }}>
        {data === FormConstants.BOOLEAN_TYPES.YES || data === true
          ? t('PRIVATE.PURGE.DISABLE', {ns: 'private'})
          : t('PRIVATE.PURGE.ENABLE', {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderIsTypeButton = (data: any, item: any): React.ReactElement => {
    return (
      <LoadingButton
        type="submit"
        variant={item.is_hyperlink ? 'text' : 'contained'}
        onClick={e => {
          if (item?.shouldNavigate && item?.navigationUrl) {
            onChange(item?.navigationUrl, data?.row);
          } else {
            props?.setState?.((prev: any) => ({
              ...prev,
              data: data,
              submodule: true
            }));
          }
        }}
        sx={{
          height: '1.8rem',
          width: '8rem',
          backgroundColor:
            data.value === FormConstants.BOOLEAN_TYPES.YES ||
            data.value === true
              ? item.is_hyperlink
                ? 'transparent'
                : theme.palette.grey[500]
              : item.is_hyperlink
                ? 'transparent'
                : theme.palette.primary.dark
        }}>
        {data?.row[item.data_column]}
      </LoadingButton>
    );
  };

  const renderBooleanCheckbox = (data: any): React.ReactElement => {
    return (
      <Checkbox
        checked={data.value}
        color="success"
        onChange={e => props?.handleBooleanCheckboxChange(e, data)}
      />
    );
  };

  const getSortField = (sortModel: any) => {
    let model = sortModel?.[0]?.field;
    const obj = sectionUIData?.fields?.find(
      (item: any) => item?.data_column === sortModel?.[0]?.field
    );
    if (obj && Object.keys(obj).length > 0 && obj?.isSchemaRequired) {
      if (obj?.dynamic_column) {
        model = obj?.schema + '.[' + sortModel?.[0]?.field + ']';
      } else {
        model = obj?.schema + '.' + sortModel?.[0]?.field;
      }
    }
    // if (model) {
    //   return `[${model}]`;
    // }

    return model;
  };

  const handleIsEdits = (e: any, data: any, id: number) => {
    const vals = {id: id, data: data};
    if (handleEditUser && typeof handleEditUser === 'function') {
      handleEditUser(vals);
    }
  };

  const handleIsdelete = (e: any, data: any, id: number) => {
    const vals = {id: id, data: data};
    if (handleDeleteUser && typeof handleDeleteUser === 'function') {
      handleDeleteUser(vals);
    }
  };

  const renderAllCustomButtons = (data: any, id: number, item: any) => {
    return (
      <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
        <LoadingButton
          type="submit"
          variant="contained"
          onClick={e => handleIsEnableds(e, data, id)}
          sx={{
            height: '1.8rem',
            width: '5rem',
            backgroundColor:
              data === FormConstants.BOOLEAN_TYPES.YES || data === 1
                ? theme.palette.primary.dark
                : theme.palette.grey[500]
          }}>
          {data === FormConstants.BOOLEAN_TYPES.YES || data === 1
            ? t('PRIVATE.COURSE_MANAGEMENT.ENABLE', {ns: 'private'})
            : t('PRIVATE.COURSE_MANAGEMENT.DISABLE', {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          type="submit"
          variant="contained"
          onClick={e => handleIsEdits(e, data, id)}
          sx={{
            height: '1.8rem',
            width: '5rem',
            backgroundColor: theme.palette.success.light
          }}>
          {t(`${item?.button_text}`, {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          type="submit"
          variant="contained"
          onClick={e => handleIsdelete(e, data, id)}
          sx={{
            height: '1.8rem',
            width: '5rem',
            backgroundColor: theme.palette.primary.lighter
          }}>
          {t(`${item?.button_text2}`, {ns: 'private'})}
        </LoadingButton>
      </div>
    );
  };

  const renderEditButton = (data: any, item: any): React.ReactElement => {
    return (
      <div style={{display: 'flex', gap: '10px'}}>
        <LoadingButton
          type="submit"
          variant="contained"
          disabled={data?.row?.login_from}
          onClick={() => editUser(data)}
          sx={{
            height: '1.8rem',
            width: '5rem',
            backgroundColor: theme.palette.primary.dark
            // fontWeight: 'normal',
            // backgroundColor: APP.PALETTE.SUB_MODULE_COLOR.BUTTON,
            // '&:hover': {
            //   backgroundColor: `${APP.PALETTE.SUB_MODULE_COLOR.HOVER_BUTTON}`,
            //   color: `${APP.PALETTE.PRIMARY.CONTRAST_TEXT}`
            // },
            // color: APP.PALETTE.PRIMARY.CONTRAST_TEXT
          }}>
          {t(`${item?.button_text}`, {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          type="submit"
          variant="contained"
          // disabled={data?.row?.login_from}
          onClick={() => DeleteUser(data)}
          sx={{
            height: '1.8rem',
            width: '5rem',
            backgroundColor: theme.palette.primary.lighter
            // fontWeight: 'normal',
            // backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.RED_BUTTON}`,
            // '&:hover': {
            //   backgroundColor: `${APP.PALETTE.ROLES.RED}`
            // },
            // color: APP.PALETTE.PRIMARY.CONTRAST_TEXT
          }}>
          {t(`${item?.button_text2}`, {ns: 'private'})}
        </LoadingButton>
      </div>
    );
  };

  const renderAcceptButton = (data: any, item: any): React.ReactElement => {
    let buttonDisableStatus = false;
    if (item.disable && item.disable.key && item.disable.in) {
      buttonDisableStatus = item.disable.in.includes(
        data.row[item.disable.key]
      );
    }
    return (
      <LoadingButton
        disabled={buttonDisableStatus}
        type="submit"
        variant="contained"
        onClick={() => props.handleAcceptButtonClick(data)}
        sx={{
          height: '1.8rem',
          width: '5rem',
          backgroundColor: theme.palette.primary.dark
        }}>
        {t(`${item?.button_text || 'Accept'}`, {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderViewButton = (data: any, item: any): React.ReactElement => {
    let buttonDisableStatus = false;
    if (item.disable && item.disable.key && item.disable.in) {
      buttonDisableStatus = item.disable.in.includes(
        data.row[item.disable.key]
      );
    }
    return (
      <LoadingButton
        disabled={buttonDisableStatus}
        type="submit"
        variant="contained"
        onClick={() => props.handleViewButtonClick(data)}
        sx={{
          height: '1.8rem',
          width: '5rem',
          backgroundColor: item?.bgColor || theme.palette.primary.dark
        }}>
        {t(`${item?.button_text || 'View'}`, {ns: 'private'})}
      </LoadingButton>
    );
  };

  const getValueOptions = async (item: any) => {
    try {
      const valueOptions: any = [];
      const values: any = {
        sql_data: item?.sql_data,
        user_id: props?.recordId,
        is_legacy_app_dropdown: true
      };
      const encryptRequestData = EncryptUtils.encryptedData(values);
      const res = await getPageData(
        applicationName,
        props?.module,
        props?.sub_module,
        {
          tk: encryptRequestData
        }
      );
      for (const ele of res.data) {
        valueOptions.push(ele?.[item?.data_column] || ele.LegacyApp);
      }

      return valueOptions;
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const logExcelData = (dataObj: any) => {
    if (dataObj?.sql_data) {
      delete dataObj.sql_data;
    }

    const keyValueString = Object.entries(dataObj)
      .map(([key, value]) => {
        if (value) return `${key}: ${JSON.stringify(value)}`;
        return null;
      })
      .filter(Boolean)
      .join(', ');

    let eventDescription = props.module ? props.module + ' -> ' : '';

    if (sectionUIData?.sql_data?.audit_event_description) {
      eventDescription += `${sectionUIData?.sql_data?.audit_event_description}`;
    } else if (sectionUIData?.name) {
      eventDescription += `${sectionUIData?.name}`;
    }

    const data = {
      module: props?.module,
      sub_module: params.submodule_name,
      sub_module_identifier: keyValueString,
      procedure_type,
      application_name: applicationName,
      isBH_selected: !isBHReason?.length && isBH == false ? true : isBH,
      isBH_reason: isBHReason,
      event_description: dataObj?.exportedAs + ' : ' + eventDescription,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(props.module, data);
  };
  const normalizeValue = (val: any) => (val === '' ? undefined : val);
  const handleExport = async () => {
    try {
      setExportExcelLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportExcel: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        tabsSubName: props?.sectionUIData?.name,
        module: props?.module,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${sortModel?.[0]?.field}`
          : getSortField(sortModel),
        sort: sortModel?.[0]?.sort
      };
      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as Excel'});
      } catch (error) {
        throw new Error('Failed to fetch Excel file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportExcelLoading(false);
    } catch (error) {
      setExportExcelLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };

  const handleCSV = async (): Promise<void> => {
    try {
      setExportCSVLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        tabsSubName: props?.sectionUIData?.name,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportCSV: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        module: props?.module,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${sortModel?.[0]?.field}`
          : getSortField(sortModel),
        sort: sortModel?.[0]?.sort
      };
      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as CSV'});
      } catch (error) {
        throw new Error('Failed to fetch CSV file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportCSVLoading(false);
    } catch (error) {
      setExportCSVLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };

  const handlePDF = async (): Promise<void> => {
    try {
      setExportPDFLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportPDF: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        module: props?.module,
        tabsSubName: props?.sectionUIData?.name,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${sortModel?.[0]?.field}`
          : getSortField(sortModel),
        sort: sortModel?.[0]?.sort
      };

      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as PDF'});
      } catch (error) {
        throw new Error('Failed to fetch PDF file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportPDFLoading(false);
    } catch (error) {
      setExportPDFLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };

  const handleClick = (group: string): void => {
    if (props && props.onCellClick()) {
      props.onCellClick(group);
    }
  };

  const renderData = (item: any, data: any) => {
    switch (true) {
      case item.show_data_button === true:
        return renderIsEnableButton(data.value, data.id);
      case item.show_data_button_action_edit === true:
        return renderAllCustomButtons(data.value, data.id, item);
      case item.show_delete_button === true:
        return renderDeleteButton(data, item);
      case item.show_users_edit_button === true:
        return renderEditButton(data, item);
      case item.show_data_button_type === true:
        return renderIsTypeButton(data, item);
      case item.show_accept_button === true:
        return renderAcceptButton(data, item);
      case item.show_view_button === true:
        return renderViewButton(data, item);
      case item.type === FormConstants.CONFIG_FIELDS_TYPE.BOOLEAN_CHECKBOX:
        return renderBooleanCheckbox(data);
      case item.type === FormConstants.CONFIG_FIELDS_TYPE.DATE:
        // Format from the raw row value with parseZone so the stored value is shown
        // as-is and never shifted to the browser's local timezone. data.value is the
        // valueGetter's Date object (a bare instant that loses the source zone), so
        // parsing it with moment(new Date(...)) would convert to local and a "...Z"
        // value would appear 4-5 hours off.
        return data.value && data.formattedValue !== 'Invalid Date'
          ? moment.parseZone(data.row[item.data_column]).format('MM/DD/YYYY')
          : '';
      case item.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME:
        if (!data.value) {
          return '';
        }
        if (item.displaytype === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME) {
          return data.formattedValue !== 'Invalid Date'
            ? moment
                .parseZone(data.row[item.data_column])
                .format('MM/DD/YYYY hh:mm:ss A')
            : '';
        }
        return data.formattedValue !== 'Invalid Date'
          ? moment.parseZone(data.row[item.data_column]).format('MM/DD/YYYY')
          : '';
      case item.is_serial_number === true:
        return data.api.getAllRowIds().indexOf(data.id) + 1;
      default:
        return data.value;
    }
  };

  // <--- Popper View --->

  interface GridCellExpandProps {
    valueObj: any;
    value: string;
    width: number;
    rowData: any;
    item: any;
    allFields: any[];
  }

  function isOverflown(element: Element): boolean {
    return (
      element.scrollHeight > element.clientHeight ||
      element.scrollWidth > element.clientWidth
    );
  }

  const GridCellExpand = React.memo(function GridCellExpand(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    props: GridCellExpandProps
  ) {
    const {width, value, valueObj, rowData} = props;
    const wrapper = React.useRef<HTMLDivElement | null>(null);
    const cellDiv = React.useRef(null);
    const cellValue = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [showFullCell, setShowFullCell] = React.useState(false);
    const [showPopper, setShowPopper] = React.useState(false);

    const handleMouseEnter = () => {
      const isCurrentlyOverflown = isOverflown(cellValue.current!);
      setShowPopper(isCurrentlyOverflown);
      setAnchorEl(cellDiv.current);
      setShowFullCell(true);
    };

    const handleMouseLeave = () => {
      setShowFullCell(false);
    };

    React.useEffect(() => {
      if (!showFullCell) {
        return undefined;
      }

      function handleKeyDown(nativeEvent: KeyboardEvent) {
        // IE11, Edge (prior to using Bink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          setShowFullCell(false);
        }
      }

      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, [setShowFullCell, showFullCell]);

    const renderValueTypography = () => {
      const {is_clickable, priority, color, data_column} = valueObj;
      const columnValue = rowData?.row?.[data_column];

      // Find all priority clickable columns with a value
      const priorityColumns =
        props?.allFields?.filter(
          (f: any) =>
            f.is_clickable &&
            f.priority &&
            rowData?.row?.[f.data_column] != null &&
            rowData?.row?.[f.data_column] !== ''
        ) || [];

      const hasPriorityColumn = priorityColumns.length > 0;

      // Priority wins: active if this column is a priority one with a value
      const isPriorityActive =
        hasPriorityColumn &&
        priority &&
        columnValue != null &&
        columnValue !== '';

      // Fallback: only check if no priority columns exist
      const fallbackColumn =
        !hasPriorityColumn &&
        (props?.allFields?.find(
          (col: any) =>
            col.is_clickable &&
            rowData?.row?.[col.data_column] != null &&
            rowData?.row?.[col.data_column] !== ''
        ) ||
          null);

      const isFallbackActive =
        !hasPriorityColumn &&
        is_clickable &&
        fallbackColumn?.data_column === data_column;

      const isActive = isPriorityActive || isFallbackActive;

      return (
        <Typography
          ref={cellValue}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor:
              rowData?.row?.ClinicalEncounterId !== null &&
              (isActive || valueObj.has_tool_tip)
                ? 'pointer'
                : 'default'
          }}
          color={
            rowData?.row?.ClinicalEncounterId !== null && isActive && color
              ? theme.palette.primary.dark
              : ''
          }>
          {value}
        </Typography>
      );
    };

    return (
      <Box
        ref={wrapper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          alignItems: 'center',
          lineHeight: '24px',
          width: props?.item?.align === 'right' ? 'unset' : '100%',
          height: '100%',
          position: 'relative',
          display: 'flex'
        }}>
        <Box
          ref={cellDiv}
          sx={{
            height: '100%',
            width,
            display: 'block',
            position: 'absolute',
            top: 0
          }}
        />
        {valueObj.has_tool_tip && valueObj.tool_tip_key ? (
          <Tooltip title={rowData?.row[valueObj.tool_tip_key] || ''}>
            {renderValueTypography()}
          </Tooltip>
        ) : (
          renderValueTypography()
        )}
        {showPopper && (
          <Popper
            open={showFullCell && anchorEl !== null}
            anchorEl={anchorEl}
            style={{width, marginLeft: -17, zIndex: 1000}}>
            <Paper
              elevation={1}
              style={{
                minHeight: wrapper.current!.offsetHeight - 3,
                maxWidth: '40vw',
                overflowY: 'auto'
              }}
              sx={{backgroundColor: 'rgba(0, 47, 85, 0.81)'}}>
              <DataGridToolTipTypography variant="subtitle1">
                {value}
                {valueObj?.showCount && value && (
                  <span
                    style={{
                      color: '#FFD700',
                      fontWeight: 'bold',
                      paddingLeft: 2
                    }}>
                    (Total Count: {value?.split(',')?.length})
                  </span>
                )}
              </DataGridToolTipTypography>
            </Paper>
          </Popper>
        )}
      </Box>
    );
  });

  // <--- Popper View --->

  const renderDataGridCell = (data: any, item: any): React.ReactElement => {
    if (item?.navigation_needed) {
      const groups = data?.value?.toString().split(',');
      return (
        <List
          style={{
            display: 'flex',
            color: APP.PALETTE.PRIMARY.MAIN
          }}>
          {groups?.map((ele: any, index: number) =>
            ele === FormConstants.USER_GROUP.NONE ? null : (
              <ListItemButton
                key={index}
                component="a"
                style={{
                  padding: '0 0.25rem',
                  textDecoration: 'underLine'
                }}
                onClick={() => handleClick(ele)}>
                {`${ele} ${index < groups.length - 1 ? ',' : ''}`}
              </ListItemButton>
            )
          )}
        </List>
      );
    } else if (item?.is_pre_formatter_required) {
      return (
        <Tooltip
          title={data.value}
          placement="bottom-start"
          // PopperProps={
          //   data.value.length > 200 // Check if the data length exceeds a threshold
          //     ? {
          //         modifiers: [
          //           {
          //             name: 'offset',
          //             options: {
          //               offset: [-900 - data.value.length, 0] // Apply the custom offset for long data
          //             }
          //           }
          //         ]
          //       }
          //     : {} // Default behavior for shorter data
          // }
        >
          <pre>{data.value}</pre>
        </Tooltip>
      );
    } else if (
      item?.has_col_span &&
      item?.col_span_config &&
      item?.col_span_config?.validation_value ===
        data.row[item?.col_span_config?.validation_key]
    ) {
      return (
        <Typography sx={{fontWeight: 600}}>
          {item?.col_span_config?.display_label
            ? data.row.label
            : item.aggregation_currency_formatter_required
              ? currencyFormatter.format(
                  data.row[item.col_span_config.display_key]
                )
              : data.row[item.col_span_config.display_key]}
        </Typography>
      );
    } else {
      const dataValue = renderData(item, data);
      return (
        <GridCellExpand
          valueObj={item}
          value={!dataValue && dataValue !== 0 ? '' : dataValue}
          rowData={data}
          width={renderData(item, data)?.colDef?.computedWidth}
          item={item}
          allFields={sectionUIData?.fields}
        />
      );
    }
  };

  const renderDataGridValueFormatter = (data: any, item: any) => {
    if (
      item?.has_col_span &&
      item?.col_span_config &&
      item?.col_span_config?.validation_value ===
        data.row[item?.col_span_config?.validation_key]
    ) {
      return (
        <Typography sx={{fontWeight: 600}}>
          {item?.col_span_config?.display_label
            ? data.row.label
            : item.aggregation_currency_formatter_required
              ? currencyFormatter.format(
                  data.row[item.col_span_config.display_key]
                )
              : data.row[item.col_span_config.display_key]}
        </Typography>
      );
    }

    if (!data.value && data.value !== 0) {
      return data.value;
    }

    return currencyFormatter.format(data.value);
  };

  const getUpdatedColumns = (list: any, valueOptions: any) => {
    const columnList: any = [];
    if (
      params.module_name === FormConstants.MODULE.CLINICAL &&
      params.submodule_name === FormConstants.SUB_MODULE.RESULTS &&
      searchFormFieldsData?.sql_data.tab_name === 'flowsheetsresults'
    ) {
      return list;
    }
    //console.log("list",list,valueOptions)
    for (const item of list) {
      if (!item.aggregation_currency_formatter_required) {
        const obj: any = {
          field: item.data_column,
          isSchemaRequired: item.isSchemaRequired,
          schemaName: item.schema,
          headerName: item.label,
          width: item.width,
          flex: Object.prototype.hasOwnProperty.call(item, 'flex')
            ? item.flex
            : 1,
          column_type: item.type,
          currnecyformatter: item.formatter,
          headerAlign: 'left',
          align: item?.align || 'left',
          type:
            item.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME
              ? FormConstants.CONFIG_FIELDS_TYPE.DATE
              : item.type,
          sortable: item?.skip_sorting ? false : true,
          filterable: item?.skip_filter ? false : true,
          format: item.formatter,
          headerClassName: item?.headerClassName || '',
          valueOptions:
            valueOptions && valueOptions.length
              ? valueOptions
              : item?.valueOptions || [],
          valueGetter: (data: any) => {
            if (data.value === null || data.value === undefined) {
              return '';
            }

            return data.value;
          },
          ...(props?.module === 'patient-accounting' && {
            sortComparator: (v1: any, v2: any) => {
              // Custom comparator for patient-accounting date columns that are stored as varchar(11)
              if (item.type === FormConstants.CONFIG_FIELDS_TYPE.DATE) {
                const parseDate = (value: any) => {
                  if (value instanceof Date) return value;
                  if (typeof value === 'number') return new Date(value);
                  if (!value || typeof value !== 'string') return new Date(0);

                  const parts = value.split('/');
                  if (parts.length === 3) {
                    return new Date(
                      parseInt(parts[2], 10),
                      parseInt(parts[0], 10) - 1,
                      parseInt(parts[1], 10)
                    );
                  }
                  return new Date(value);
                };
                const date1 = parseDate(v1);
                const date2 = parseDate(v2);
                return date1.getTime() - date2.getTime();
              }
              return 0;
            }
          }),
          renderCell: (data: any) => renderDataGridCell(data, item),
          editable: item?.editable || false
        };

        if (item.has_col_span) {
          obj.colSpan = (data: any) => {
            if (
              item?.has_col_span &&
              item?.col_span_config &&
              item?.col_span_config?.validation_value ===
                data.row[item?.col_span_config?.validation_key]
            ) {
              return item.col_span_config.col_span;
            }
            return 0;
          };
        }

        columnList.push(obj);

        if (item.type) {
          if (rowsData[0] != 'submoduledatapassed') {
            for (const rowItem of rowsData) {
              rowItem[item.data_column] = HelperUtils.formatData(
                rowItem[item.data_column],
                item.type,
                item.formatter
              );
            }
          }
        }
      } else if (item.aggregation_currency_formatter_required) {
        const obj: any = {
          field: item.data_column,
          headerName: item.label,
          flex: Object.prototype.hasOwnProperty.call(item, 'flex')
            ? item.flex
            : 1,
          type: item.type,
          filterable: item?.skip_filter ? false : true,
          sortable: item?.skip_sorting ? false : true,
          format: item.formatter,
          renderCell: (data: any) => renderDataGridValueFormatter(data, item),
          align: item?.align || 'left'
        };
        if (item.width) {
          obj.width = item.width;
        }

        if (item.has_col_span) {
          obj.colSpan = (data: any) => {
            if (
              item?.has_col_span &&
              item?.col_span_config &&
              item?.col_span_config?.validation_value ===
                data.row[item?.col_span_config?.validation_key]
            ) {
              return item.col_span_config.col_span;
            }
            return 0;
          };
        }

        columnList.push(obj);
      }
    }
    return columnList;
  };

  // const handleGridMenuClose = (value: string) => {
  //   setTableSizeMenu(false);
  //   setGridHeight(value);
  // };

  const CustomToolbar = () => (
    <GridToolbarContainer
      sx={{display: 'flex', alignItems: 'center', position: 'relative'}}>
      {enableGridSearch && (
        <GridToolbarQuickFilter
          className="quick-search-filter"
          sx={{
            right: 15,
            width: '200px !important',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0000003b',
              borderWidth: '1.8px'
            },
            '& svg': {
              color: theme.palette.primary.lighter
            },
            '& .MuiInputBase-inputAdornedEnd': {
              padding: '7.5px 7px !important'
            }
          }}
        />
      )}
      <Box sx={{flexGrow: 1}} />
      {/* <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector /> */}
      {/* <div ref={anchorRef}>
        <Fab
          onClick={() => setTableSizeMenu(true)}
          key={'table-length'}
          variant="outlinedExtended"
          size="small">
          <Iconify icon="ic:baseline-view-day" width={24} />
          Grid Height
        </Fab>
      </div>
      {tableSizeMenu && anchorRef?.current ? (
        <Menu
          sx={{position: 'absolute'}}
          id="demo-positioned-menu"
          anchorEl={anchorRef.current}
          open={tableSizeMenu}
          onClose={() => setTableSizeMenu(false)}
          // getContentAnchorEl={null}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}>
          <MenuItem
            selected={gridHeight == '50vh'}
            onClick={() => handleGridMenuClose('50vh')}>
            small
          </MenuItem>
          <MenuItem
            selected={gridHeight == '70vh'}
            onClick={() => handleGridMenuClose('70vh')}>
            medium
          </MenuItem>
          <MenuItem
            selected={gridHeight == '100vh'}
            onClick={() => handleGridMenuClose('100vh')}>
            large
          </MenuItem>
        </Menu>
      ) : null} */}
      {sectionUIData.is_export_data_needed ? (
        <>
          <Tooltip title="Download as Excel Spreadsheet" arrow>
            <LoadingButton
              onClick={() => {
                if (props?.module === 'custom_reports') {
                  // handleExport();
                  if (
                    rowsCountData >
                    (environment?.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT ?? 5000)
                  ) {
                    setShowDialogOpen(true);
                    setActiveAction('excel');
                  } else {
                    handleExport();
                  }
                } else {
                  handleExport();
                }
              }}
              variant="contained"
              color="primary"
              loading={excelloading}>
              Export to Excel
            </LoadingButton>
          </Tooltip>
          <Tooltip title="Download as CSV" arrow>
            <LoadingButton
              onClick={() => {
                if (props?.module === 'custom_reports') {
                  // handleExport();
                  if (
                    rowsCountData >
                    (environment?.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT ?? 5000)
                  ) {
                    setShowDialogOpen(true);
                    setActiveAction('csv');
                  } else {
                    handleCSV();
                  }
                } else {
                  handleCSV();
                }
              }}
              variant="contained"
              color="primary"
              loading={csvloading}>
              Export to CSV
            </LoadingButton>
          </Tooltip>
          {/* <Tooltip title="Download as Pdf" arrow>
            <LoadingButton
              onClick={handlePDF}
              variant="contained"
              color="primary"
              loading={pdfloading}>
              Export to PDF
            </LoadingButton>
          </Tooltip>
        </>
      ) : null} */}
          {/* Show PDF only if not EMTALA_Report_Results */}
          {sectionUIData?.name !== 'EMTALA_Report_Results' && (
            <Tooltip title="Download as PDF" arrow>
              <LoadingButton
                onClick={handlePDF}
                variant="contained"
                color="primary"
                loading={pdfloading}>
                Export to PDF
              </LoadingButton>
            </Tooltip>
          )}
        </>
      ) : null}
    </GridToolbarContainer>
  );

  const addCustomFilters = (
    columnData: [],
    columnName: string,
    valueOptions: []
  ) => {
    const updatedColumn: any[] = columnData.map((item: any) => {
      if (item?.field == columnName) {
        return {
          ...item,
          valueOptions: valueOptions
        };
      } else {
        return item;
      }
    });
    return updatedColumn;
  };

  const init = async () => {
    let valueOptions: any = [];
    const legacyFilterItem = columnData?.find(
      (item: any) =>
        item?.filterable &&
        item?.type === FormConstants.CONFIG_FIELDS_TYPE.SINGLE_SELECT
    );
    //console.log('legacyFilterItem', legacyFilterItem);
    if (legacyFilterItem?.sql_data) {
      valueOptions = await getValueOptions(legacyFilterItem);
    }
    let columns = getUpdatedColumns(columnData || [], valueOptions);

    const preDefinedList = columnData?.filter(
      (item: any) =>
        item?.filterable &&
        item?.type === FormConstants.CONFIG_FIELDS_TYPE.SINGLE_SELECT &&
        item?.pre_defined_list
    );

    if (preDefinedList?.length) {
      preDefinedList.map((filterItem: any) => {
        const optionsList =
          environment?.dropDownOptionsList?.[filterItem?.pre_defined_list];

        columns = addCustomFilters(
          columns,
          filterItem?.pre_defined_list,
          optionsList
        );
      });
    }
    //console.log('columns', columns);
    setMainColumns(columns);
  };

  const detectApiLoaderChanges = (loading: any): void => {
    setIsEnabled(loading);
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sectionUIData?.sql_data?.sql,
    sectionUIData?.update_is_enable_sql,
    sectionUIData
  ]);

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getPageCount = (rowCount: number, pageSize: number): number => {
    if (pageSize > 0 && rowCount > 0) {
      return Math.ceil(rowCount / pageSize);
    }
    return 0;
  };

  // React.useEffect(() => {
  //   if (!rowsData?.length) {
  //     setRowsCountData(0);
  //   }
  // }, [rowsData]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const CustomPaginationOld = (): React.ReactElement => {
    const gridApiContext = useGridApiContext();
    const [pageSize, setPageSize] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );
    const [pageSizes, setPageSizes] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );
    const page = useGridSelector(gridApiContext, gridPageSelector);
    // const pageCount = useGridSelector(gridApiContext, gridPageCountSelector);
    const rowCount = useGridSelector(gridApiContext, gridRowCountSelector);
    // const pageSizes = useGridSelector(gridApiContext, gridPageSizeSelector);
    const pageCount = getPageCount(rowCount, pageSize);

    React.useEffect(() => {
      gridApiContext.current.setPageSize(pageSizes);
      setPageSize(pageSizes);
      setpagesizecount(page);
      settotalPagesizevalue(pageSizes);
      settotalPagesize(rowCount);
    }, [pageSizes, page]);

    React.useEffect(() => {
      if (
        ((sectionUIData.label === 'Reports' ||
          sectionUIData.label === 'Report Log') &&
          radiochangevalue === 'created_by_me') ||
        radiochangevalue === 'created_by_all'
      ) {
        if (radiochangedata != radiochangevalue) {
          setRadiochangevalue(radiochangevalue);
          gridApiContext.current.setPage(0);
        }
      }
    }, [radiochangevalue]);

    const TablePaginationRows = () => {
      const handleChangePage = (event: any, newPage: number) => {
        gridApiContext.current.setPage(newPage);
      };

      const handleChangePageSize = (event: any) => {
        setPageSizes(parseInt(event.target.value, 10));
        gridApiContext.current.setPage(0);
      };

      return (
        <TablePaginationWrapper>
          <TablePagination
            className="pagination-container"
            component="div"
            count={rowCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handleChangePageSize}
            rowsPerPageOptions={environment.rowsPerPageOptions}
          />
        </TablePaginationWrapper>
      );
    };

    return (
      <>
        <RowsCountDivStyle>
          {`Total Rows: ${rowsCountData ? rowsCountData : rowsData.length}`}
        </RowsCountDivStyle>
        <TablePaginationRows />
        <PaginationStyle
          className="pp"
          color="primary"
          count={pageCount}
          page={page + 1}
          showFirstButton
          showLastButton
          onChange={(event: any, value: any) =>
            gridApiContext.current.setPage(value - 1)
          }
          siblingCount={1}
          boundaryCount={0}
        />
      </>
    );
  };

  function CustomPagination() {
    const gridApiContext = useGridApiContext();

    const [pageSize, setPageSize] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );
    const [pageSizes, setPageSizes] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );

    const page = useGridSelector(gridApiContext, gridPageSelector);
    const rowCount = useGridSelector(gridApiContext, gridRowCountSelector);
    const pageCount = getPageCount(rowCount, pageSize);
    const handleChangePage = (event: any, newPage: number) => {
      gridApiContext.current.setPage(newPage);
    };
    if (
      rowsPAData &&
      rowsPAData[0] &&
      rowsPAData[0]?.SaveRecords &&
      rowsPAData[0]?.SaveRecords === 'true'
    ) {
      const existing = localStorage.getItem('PATabledata');
      const base = existing ? JSON.parse(existing) : {};
      localStorage.setItem(
        'PATabledata',
        JSON.stringify({
          ...base,
          offset: page,
          pageCount: pageCount,
          pageSize: pageSize
        })
      );
    }

    const handleChangePageSize = (event: any) => {
      setPageSizes(parseInt(event.target.value, 10));
      gridApiContext.current.setPage(0);
    };

    React.useEffect(() => {
      gridApiContext.current.setPageSize(pageSizes);
      setPageSize(pageSizes);
      setpagesizecount(page);
      settotalPagesizevalue(pageSizes);
      settotalPagesize(rowCount);
    }, [pageSizes, page]);

    React.useEffect(() => {
      if (
        ((sectionUIData.label === 'Reports' ||
          sectionUIData.label === 'Report Log') &&
          radiochangevalue === 'created_by_me') ||
        radiochangevalue === 'created_by_all'
      ) {
        if (radiochangedata != radiochangevalue) {
          setRadiochangevalue(radiochangevalue);
          gridApiContext.current.setPage(0);
        }
      }
    }, [radiochangevalue]);

    return (
      <>
        <RowsCountDivStyle className="MuiRowsCount">
          {`Total Rows: ${rowsCountData ? rowsCountData : rowsData.length}`}
        </RowsCountDivStyle>
        <GridPagination
          ActionsComponent={paginationProps => (
            <MuiPagination
              className="pp"
              color="primary"
              count={pageCount}
              page={page + 1}
              showFirstButton
              showLastButton
              onChange={(event: any, value: any) =>
                gridApiContext.current.setPage(value - 1)
              }
              siblingCount={1}
              boundaryCount={0}
            />
          )}
          className="pagination-container"
          component="div"
          count={rowCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangePageSize}
          rowsPerPageOptions={environment.rowsPerPageOptions}
        />
      </>
    );
  }

  React.useEffect(() => {
    let checkedRowIdsList: any = [];
    if (getLocaleStorageData) {
      const data = JSON.parse(getLocaleStorageData);

      if (data) {
        const checkedRowIds = data?.map((row: any) => {
          return row?.ID;
        });

        if (checkedRowIds && checkedRowIds.length)
          checkedRowIdsList = checkedRowIds;
      }
    }
    if (
      getAdditionalLocaleStorageData &&
      localStorage.getItem('patient_encounterData_removed') === 'false'
    ) {
      const data = JSON.parse(getAdditionalLocaleStorageData);

      if (data) {
        const checkedRowIds = data?.map((row: any) => {
          return row?.ID;
        });

        if (checkedRowIds && checkedRowIds.length)
          checkedRowIdsList = checkedRowIds;
      }
    }
    setSelectedRowIds(checkedRowIdsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    detectApiLoaderChanges(apiLoader);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiLoader]);

  const renderList = (header: string, data: any): React.ReactElement => {
    return (
      <RenderListDiv key={data}>
        <DetailPanelDiv>{header}</DetailPanelDiv>
        <RenderListUL>
          {data?.map((item: any, index: number) => {
            return <RenderListLI key={index}>{item?.data}</RenderListLI>;
          })}
        </RenderListUL>
      </RenderListDiv>
    );
  };

  const renderCard = (subSectionData: any, row: any) => {
    return (
      <CardComponent
        key={subSectionData?.name}
        fields={subSectionData?.fields}
        data={[]}
        columns_per_row={subSectionData?.columns}
        is_border_required={true}
        is_space_needed_between_label_value={false}
        is_colon_needed={true}
        module={props?.module}
        sub_module={props?.sub_module}
        sectionUIData={subSectionData}
        selectedRowDetails={row}
        currentTab={currentTab}
        specimen_number_id={specimen_number_id}
        specimen_number={specimen_number}
        procedure_id={procedure_id}
        procedure_type={procedure_type}
        demographic_id={props?.demographic_id}
        recordId={recordId}
      />
    );
  };

  const renderTaskCard = (subSectionData: any, row: any) => {
    return (
      <TaskCardComponent
        key={subSectionData?.name}
        fields={subSectionData?.fields}
        data={[]}
        columns_per_row={subSectionData?.columns}
        is_border_required={true}
        is_space_needed_between_label_value={false}
        is_colon_needed={true}
        module={props?.module}
        sub_module={props?.sub_module}
        sectionUIData={subSectionData}
        selectedRowDetails={row}
      />
    );
  };

  const handleTabChange = (tabValue: string, ID: string) => {
    const id = '@' + ID + '@';
    const selectedTabData = sectionUIData?.sub_sections?.find(
      (item: any) => item.name === tabValue
    );

    let tabSelection: any;
    if (Object.keys(currentTab).length) {
      tabSelection = currentTab;
    } else {
      const tabValueObj = {[id]: tabValue};
      tabSelection = tabValueObj;
    }
    tabSelection[id] = tabValue;
    setCurrentTab({...tabSelection});

    let tabDataSelection: any;
    if (Object.keys(tabsSubSecData).length) {
      tabDataSelection = tabsSubSecData;
    } else {
      const selectedTabDataObj = {[id]: selectedTabData};
      tabDataSelection = selectedTabDataObj;
    }
    tabDataSelection[id] = selectedTabData;
    setTabsSubSecData({...tabDataSelection});
    return selectedTabData;
  };

  const renderDocumentComponent = (item: any, subSectionData: any) => {
    return (
      <DocumentsComponent
        subModuleUIData={item}
        subModuleData={[]}
        module={props?.module}
        sub_module={props?.sub_module}
        patient_id={
          item?.record_id ||
          props?.selectedRowDetails?.row?.PatientInformationID
        }
        legacyApp={item?.legacyApp}
        unique_id={item?.unique_id}
        ParentLegacyValue={''}
        rowData={subSectionData?.row?.row}
        top={'12%'}
      />
    );
  };

  const renderPeriodontalChart = (item: any, subSectionData: any) => {
    return (
      <PeriodontalChartComponent
        module={props?.module}
        sub_module={props?.sub_module}
        subModuleUIData={item}
        rowId={subSectionData?.id}
      />
    );
  };

  const renderVitalComponent = (
    item: any,
    subSectionData: any
  ): React.ReactElement => {
    const legacy_app = AuthUtils.getAuditLegacyApp();
    return (
      <VitalsComponent
        sectionUIData={item}
        sectionRowsData={[]}
        ParentLegacyValue={subSectionData?.row?.legacyApp || legacy_app}
        rowId={subSectionData?.id}
      />
    );
  };

  const renderTabs = (subSectionsData: any, row: any) => {
    let colList = subSectionsData?.subSection?.sub_sections || [];
    if (
      props?.module === 'patient-accounting' &&
      props?.sub_module === 'invoice' &&
      row?.row?.IsRCMTransaction &&
      subSectionsData?.subSection?.rcm_transaction_sub_sections &&
      subSectionsData?.subSection?.rcm_transaction_sub_sections?.length
    ) {
      subSectionsData?.subSection?.rcm_transaction_sub_sections?.map(
        (s: any) => {
          colList = colList.filter((c: any) => c.name === s.name);
        }
      );
    }
    if (props?.module === 'lis' && props?.sub_module === 'demographics') {
      colList = colList.filter((c: any) => {
        if (c.tabs_view_enabled && procedure_id) {
          return false;
        }

        return true;
      });
    }
    const [firstTab] = colList;

    let actualID = row.id;
    actualID = '@' + actualID + '@';

    const selectedTab = Object.keys(currentTab).length
      ? currentTab[`${actualID}`]
      : firstTab?.name;

    const selectedTabData =
      colList.find((tab: any) => tab.name === selectedTab) || firstTab;

    return (
      <RenderTabsDiv>
        <SubTabsComponent
          selectedTab={selectedTab}
          routesData={colList}
          action={name => handleTabChange(name, row.id)}
          initialTab={selectedTab || firstTab?.name}
          {...row}
        />
        <RenderTabsContentDiv>
          {selectedTabData?.sub_sections?.map((item: any) => {
            return (
              <div key={item?.name}>
                {item?.type === FormConstants.DATA_GRID_TYPES.SELECT ? (
                  renderVitalComponent(item, row)
                ) : item?.type === FormConstants.DATA_GRID_TYPES.LIST ? (
                  renderList('Tabs Content', item || [])
                ) : item?.type === FormConstants.DATA_GRID_TYPES.DATA_GRID ? (
                  <CollapsibleTable
                    key={item?.name}
                    sectionUIData={item}
                    sectionRowsData={[]}
                    module={props?.module}
                    sub_module={props?.sub_module}
                    selectedRowDetails={row}
                    searchFormFieldsData={searchFormFieldsData}
                    onCellClick={(e: any) => handleCellClicked(e, item)}
                    specimen_number_id={props?.specimen_number_id}
                    specimen_number={props?.specimen_number}
                    procedure_id={props?.procedure_id}
                    procedure_type={procedure_type}
                    demographic_id={props?.demographic_id}
                  />
                ) : item?.type === FormConstants.DATA_GRID_TYPES.TASKCARD ? (
                  renderTaskCard(item, row)
                ) : item?.type ===
                  FormConstants.PAGE_SECTION_TYPES.DOCUMENTS ? (
                  renderDocumentComponent(item, subSectionsData)
                ) : item?.type === FormConstants.DATA_GRID_TYPES.CARD ? (
                  renderCard(item, row)
                ) : item?.type ===
                  FormConstants.PAGE_SECTION_TYPES.PERIODONTAL_CHART ? (
                  renderPeriodontalChart(item, row)
                ) : props?.module === FormConstants.MODULE.CLINICAL &&
                  props?.sub_module === FormConstants.SUB_MODULE.TRANSFUSION &&
                  selectedTab === 'vital' ? (
                  renderVitalComponent(item, row)
                ) : null}
              </div>
            );
          })}
        </RenderTabsContentDiv>
      </RenderTabsDiv>
    );
  };

  const getSubSectionData = (subSectionData: any, row: any) => {
    const subData = subSectionData?.subSection?.sub_sections?.[0];

    if (subData && Object.entries(subData).length) {
      if (subData.benefit_types) {
        const benefittypeslist = subData.benefit_types_list;
        const BenefitType = row?.row?.BenefitType;
        if (benefittypeslist.includes(BenefitType?.toLowerCase())) {
          return subData.benefit_types[BenefitType.toLowerCase()];
        } else {
          return subData.benefit_types['generic'];
        }
      }
      return subData;
    }
  };

  const DetailPanelContent = (subSectionData: any) => {
    const row = subSectionData?.row || {};
    const subSectionType = subSectionData.subSection?.sub_section_type;

    const [previewClaimLoading, setPreviewClaimLoading] = React.useState(false);
    const [printClaimLoading, setPrintClaimLoading] = React.useState(false);
    const [paStatementLoading, setPaStatementLoading] = React.useState(false);
    const [pdfStatementLoading, setPdfStatementLoading] = React.useState(false);
    const [printTextLoading, setPrintTextLoading] = React.useState(false);
    const [claimDataBuffer, setClaimDataBuffer] = React.useState('');
    const [previewClaimFormDialog, setPreviewClaimFormDialog] =
      React.useState(false);
    const [currentClaimType, setCurrentClaimType] = React.useState('');
    const onClosePreviewClaimFormDialog = () => {
      setPreviewClaimFormDialog(false);
      setCurrentClaimType('');
    };

    const onPreviewButtonClick = async (
      claimType: any,
      claimId: any,
      claimConfig: any
    ) => {
      setPreviewClaimFormDialog(true);
      setCurrentClaimType(claimType);
      const tk = EncryptUtils.encryptedData({
        claimId,
        claimConfig
      });
      setPreviewClaimLoading(true);
      try {
        const res = await getClaimPreviewPdf({tk}, claimType);
        setPreviewClaimLoading(false);
        setClaimDataBuffer(res.dataBuffer);
      } catch (e) {
        setPreviewClaimLoading(false);
      }
    };

    const onPrintButtonClick = async (
      claimType: any,
      claimId: any,
      claimConfig: any
    ) => {
      const tk = EncryptUtils.encryptedData({
        claimId,
        claimConfig
      });
      try {
        setPrintClaimLoading(true);
        const response = await getPrintedClaim({tk}, claimType);
        const blob = response?.data;
        const blobUrl = URL.createObjectURL(blob);
        
        // Use window.open to avoid cross-origin framing restrictions
        const printWindow = window.open(blobUrl, '_blank');
        if (printWindow) {
          // Small delay to ensure the document loads before printing
          setTimeout(() => {
            printWindow.print();
            // Clean up after print dialog closes
            const cleanup = () => {
              printWindow.close();
              URL.revokeObjectURL(blobUrl);
            };
            printWindow.addEventListener('afterprint', cleanup);
          }, 250);
        } else {
          // Fallback: if popup is blocked, create hidden iframe with sandbox
          const iframe = document.createElement('iframe');
          iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          iframe.onload = () => {
            setTimeout(() => {
              iframe.focus();
              iframe.contentWindow?.print?.();
            }, 250);
            const cleanup = () => {
              URL.revokeObjectURL(blobUrl);
              document.body.removeChild(iframe);
            };
            iframe.addEventListener('afterprint', cleanup);
          };
        }
        setPrintClaimLoading(false);
      } catch (e) {
        console.error('Error printing claim:', e);
        setPrintClaimLoading(false);
      }
    };

    const onPrintTextButtonClick = async (
      claimType: any,
      claimId: any,
      claimConfig: any
    ) => {
      const tk = EncryptUtils.encryptedData({
        claimId,
        claimConfig
      });
      try {
        setPrintTextLoading(true);
        const response = await getTextClaim({tk}, claimType);
        const blob = response?.data;
        const blobUrl = URL.createObjectURL(blob);
        
        // Use window.open to avoid cross-origin framing restrictions
        const printWindow = window.open(blobUrl, '_blank');
        if (printWindow) {
          // Small delay to ensure the document loads before printing
          setTimeout(() => {
            printWindow.print();
            // Clean up after print dialog closes
            const cleanup = () => {
              printWindow.close();
              URL.revokeObjectURL(blobUrl);
            };
            printWindow.addEventListener('afterprint', cleanup);
          }, 250);
        } else {
          // Fallback: if popup is blocked, create hidden iframe with sandbox
          const iframe = document.createElement('iframe');
          iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          iframe.onload = () => {
            setTimeout(() => {
              iframe.focus();
              iframe.contentWindow?.print?.();
            }, 250);
            const cleanup = () => {
              URL.revokeObjectURL(blobUrl);
              document.body.removeChild(iframe);
            };
            iframe.addEventListener('afterprint', cleanup);
          };
        }
        setPrintTextLoading(false);
      } catch (e) {
        console.error('Error printing text claim:', e);
        setPrintTextLoading(false);
      }
    };

const onPaButtonClick = async (
  statementType: any,
  accountId: any,
  subSectionConfig: any
) => {
  void statementType;
  let pdfContainer: HTMLDivElement | null = null;
  let measurementContainer: HTMLDivElement | null = null;

  const tk = EncryptUtils.encryptedData({
    accountId,
    subSectionConfig
  });

  try {
    setPaStatementLoading(true);

    const response = await getStatementPdfPA({ tk });
    // console.log('response==>',response)
    const paData = response?.data || [];
    // console.log('paData==>',paData);
    if (!Array.isArray(paData) || paData.length === 0) {
          enqueueSnackbar(
      'No Account statement data returned from server',
      SnackBarConfig.getSuccess()
    );
    
    }

    const header = paData[0];
    const statementRows = paData.filter((item: any) => item?.Description);
    // console.log('statementRows==>',statementRows);
    const BalanceRows = paData.filter(
      (item: { Balance?: number }) => typeof item.Balance === 'number'
    );
    const TotalAccountBalanceRows = paData.filter((item: any) => item?.TotalAccountBalance);
    const totalAccountBalanceValue = Number(
      TotalAccountBalanceRows[0]?.TotalAccountBalance ?? 0
    );
    // console.log('Total Account Balance2701-->:', totalAccountBalanceValue);
    // const shouldShowTotalBalanceSection = totalAccountBalanceValue > 0;
    const statementNumber = String(accountId);
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const topMargin = 15;
    const bottomMargin = 15;
    const usableHeight = pdfHeight - topMargin - bottomMargin;
    const pageWidthPx = 816;
    const usablePageHeightPx = Math.floor(
      (usableHeight * pageWidthPx) / pdfWidth
    );
    const tableStyle =
      'width:100%; border-collapse:collapse; font-size:12px; table-layout:fixed;';
    const cellStyle = 'word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; overflow: hidden;';
    const statementHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th style="${cellStyle}">Invoice Number</th>
          <th style="${cellStyle}">Description</th>
          <th style="${cellStyle}">Date of Service</th>
          <th style="${cellStyle}">Charges</th>
          <th style="${cellStyle}">Payments</th>
          <th style="${cellStyle}">Adjustments</th>
        </tr>
      </thead>
    `;
    const invoiceLevelHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th colspan="5" style="text-align:center; font-weight:700;">
            Invoice Level Total
          </th>
        </tr>
        <tr style="background:#adadad;">
          <th style="${cellStyle}">Invoice Number</th>
          <th style="${cellStyle}">Charges</th>
          <th style="${cellStyle}">Payments</th>
          <th style="${cellStyle}">Adjustments</th>
          <th style="${cellStyle}">Balance</th>
        </tr>
      </thead>
    `;
    const totalBalanceHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th colspan="8" style="text-align:center; font-weight:700;">
            Total Balance
          </th>
        </tr>
        <tr style="background:#adadad;">
          <th style="${cellStyle}">Account Number</th>
          <th style="${cellStyle}">30 Days</th>
          <th style="${cellStyle}">60 Days</th>
          <th style="${cellStyle}">90 Days</th>
          <th style="${cellStyle}">120 Days</th>
          <th style="${cellStyle}">365 Days</th>
          <th style="${cellStyle}">Over 365 Days</th>
          <th style="${cellStyle}">Total Account Balance</th>
        </tr>
      </thead>
    `;
    const formatAmount = (value: number) => (value ? `$${value.toFixed(2)}` : '');
    const headerSectionHtml = `
      <div style="background: #adadad; text-align:center; padding:10px; font-size:20px; font-weight:700; margin-bottom:16px;">
       Account Statement
      </div>

      <div style="display:flex; justify-content:space-between; gap:24px; margin-bottom:16px; font-size:12px;">
        <div>
          <div style="background: #adadad"><b>Billed By:</b></div>
          <div>${header?.BilledBy_Name || ''}</div>
          <div>${header?.BilledBy_AddressLine1 || ''}</div>
          <div>${header?.BilledBy_City || ''}, ${header?.BilledBy_State || ''} ${header?.BilledBy_Zipcode || ''}</div>
          <div>${header?.BilledBy_Phone || ''}</div>
        </div>

        <div>
          <div><b>Date:</b> ${header?.Date || ''}</div>
          <div><b>Customer Name:</b> ${header?.CustomerName || ''}</div>
          <div><b>Legacy MRN:</b> ${header?.LegacyMRN || ''}</div>
          <div><b>Account Number:</b> ${header?.AccountNumber || ''}</div>
        </div>
      </div>
    `;
    const buildStatementRowHtml = (item: any) => {
      const invoiceNumber = item?.InvoiceNumber || '';
      const charges = Number(item?.Charges || 0);
      const payments = Number(item?.Payments || 0);
      const adjustment = Number(item?.Adjustment || 0);
      const txDate = item?.ServiceDate
        ? moment(item.ServiceDate,'YYYY-MM-DD HH:mm:ss.SSS').format('MM/DD/YYYY')
        : '';
// console.log('txDate==>',txDate);
      return `
        <tr>
          <td style="${cellStyle}">${invoiceNumber}</td>
          <td style="${cellStyle}">${item?.DescriptionS || 'N/A'}</td>
          <td style="${cellStyle}">${txDate}</td>
          <td style="${cellStyle}" align="right">${formatAmount(charges)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(payments)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(adjustment)}</td>
        </tr>
      `;
    };
    const buildInvoiceLevelRowHtml = (item: any) => {
      const invoiceNumber = item?.InvoiceNumber || '';
      const charges = Number(item?.Charges || 0);
      const payments = Number(item?.Payments || 0);
      const adjustment = Number(item?.Adjustment || 0);
      const balance = Number(item?.Balance || 0);

      return `
        <tr>
          <td style="${cellStyle}">${invoiceNumber}</td>
          <td style="${cellStyle}" align="right">${formatAmount(charges)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(payments)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(adjustment)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(balance)}</td>
        </tr>
      `;
    };
    const buildTotalBalanceRowHtml = (item: any) => {
      const accountnumber = item?.AccountNumber || '';
      const days_30 = Number(item?.['0-30'] ?? 0);
      const days_60 = Number(item?.['31-60'] ?? 0);
      const days_90 = Number(item?.['61-90'] ?? 0);
      const days_120 = Number(item?.['91-120'] ?? 0);
      const days_365 = Number(item?.['121-365'] ?? 0);
      const over_365_days = Number(item?.['365+'] ?? 0);
      const totalAccountBalance = Number(item?.TotalAccountBalance ?? 0);

      return `
        <tr>
          <td style="${cellStyle}">${accountnumber}</td>
          <td style="${cellStyle}" align="right">${formatAmount(days_30)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(days_60)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(days_90)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(days_120)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(days_365)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(over_365_days)}</td>
          <td style="${cellStyle}" align="right">${formatAmount(totalAccountBalance)}</td>
        </tr>
      `;
    };
    const buildStatementTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}" border="1" cellspacing="0" cellpadding="5">
        ${statementHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const buildInvoiceLevelTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}; margin-top:24px;" border="1" cellspacing="0" cellpadding="5">
        ${invoiceLevelHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const buildTotalBalanceTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}; margin-top:24px;" border="1" cellspacing="0" cellpadding="5">
        ${totalBalanceHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const messageHtml = `
      <div style="display:flex; justify-content:space-between; gap:24px; margin-top:16px; font-size:12px;">
        <div>
          <div>Message :</div>
          <div>Please Make sure coordination of benefits are up to date</div>
        </div>

        <div style="border:2px solid #242424; height:100px; padding:10px; font-size:15px; font-weight:700;">
          <div>
              ${
                totalAccountBalanceValue > 0
                  ? `Please pay this <br/> Amount >>> ${formatAmount(totalAccountBalanceValue)}`
                  : totalAccountBalanceValue < 0
                  ? `${formatAmount(totalAccountBalanceValue)}`
                  : 'Paid in full'
              }
          </div>
        </div>
      </div>
    `;
    const buildPageHtml = (contentHtml: string) => `
      <div style="font-family: Arial, sans-serif; padding:32px; color:#333; background:#fff; width:${pageWidthPx}px; box-sizing:border-box;">
        ${contentHtml}
      </div>
    `;
    const addInvisibleTextLayer = (pageElement: HTMLElement) => {
      const pageRect = pageElement.getBoundingClientRect();
      const pxToMm = pdfWidth / pageWidthPx;
      const getTextSegments = (textNode: Text) => {
        const rawText = textNode.textContent || '';
        const segments: Array<{text: string; rect: DOMRect}> = [];
        const lineTolerance = 1;
        let pendingWhitespace = '';

        for (let index = 0; index < rawText.length; index += 1) {
          const character = rawText[index];
          const charRange = document.createRange();
          charRange.setStart(textNode, index);
          charRange.setEnd(textNode, index + 1);
          const rect = charRange.getBoundingClientRect();

          if (rect.width === 0 || rect.height === 0) {
            if (/\s/.test(character)) {
              pendingWhitespace += ' ';
            }
            continue;
          }

          const lastSegment = segments[segments.length - 1];
          const isSameLine =
            !!lastSegment &&
            Math.abs(lastSegment.rect.top - rect.top) <= lineTolerance &&
            Math.abs(lastSegment.rect.bottom - rect.bottom) <= lineTolerance;

          if (!lastSegment || !isSameLine) {
            segments.push({
              text: `${pendingWhitespace}${character}`,
              rect
            });
          } else {
            lastSegment.text += `${pendingWhitespace}${character}`;
            lastSegment.rect = new DOMRect(
              lastSegment.rect.left,
              Math.min(lastSegment.rect.top, rect.top),
              rect.right - lastSegment.rect.left,
              Math.max(lastSegment.rect.bottom, rect.bottom) -
                Math.min(lastSegment.rect.top, rect.top)
            );
          }

          pendingWhitespace = '';
        }

        return segments
          .map(segment => ({
            text: segment.text.replace(/\s+/g, ' ').trim(),
            rect: segment.rect
          }))
          .filter(segment => segment.text);
      };
      const walker = document.createTreeWalker(pageElement, NodeFilter.SHOW_TEXT, {
        acceptNode: node => {
          const text = node.textContent?.trim();
          return text ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });

      let currentNode = walker.nextNode();

      while (currentNode) {
        const textNode = currentNode as Text;
        const parentElement = textNode.parentElement;

        if (parentElement) {
          const textSegments = getTextSegments(textNode);

          if (textSegments.length > 0) {
            const style = window.getComputedStyle(parentElement);
            const fontSize = Math.max(
              6,
              parseFloat(style.fontSize || '12') * 0.75
            );

            pdf.setFontSize(fontSize);

            textSegments.forEach(segment => {
              const x = (segment.rect.left - pageRect.left) * pxToMm;
              const y = topMargin + (segment.rect.bottom - pageRect.top) * pxToMm;

              pdf.text(segment.text, x, y, {
                renderingMode: 'invisible' as any
              });
            });
          }
        }

        currentNode = walker.nextNode();
      }
    };

    measurementContainer = document.createElement('div');
    measurementContainer.style.position = 'fixed';
    measurementContainer.style.left = '-99999px';
    measurementContainer.style.top = '0';
    measurementContainer.style.width = `${pageWidthPx}px`;
    measurementContainer.style.opacity = '0';
    measurementContainer.style.pointerEvents = 'none';
    document.body.appendChild(measurementContainer);

    const getMeasuredHeight = (contentHtml: string) => {
      if (!measurementContainer) {
        return 0;
      }

      measurementContainer.innerHTML = buildPageHtml(contentHtml);
      return measurementContainer.offsetHeight;
    };

    const paginateRows = (
      rows: any[],
      buildRowHtml: (item: any) => string,
      buildTableHtml: (rowsHtml: string) => string,
      firstPageIntroHtml: string,
      continuationIntroHtml = ''
    ) => {
      if (rows.length === 0) {
        return [];
      }

      const pages: string[] = [];
      let currentRowsHtml = '';
      let isFirstPage = true;

      rows.forEach(item => {
        const nextRowsHtml = `${currentRowsHtml}${buildRowHtml(item)}`;
        const introHtml = isFirstPage ? firstPageIntroHtml : continuationIntroHtml;
        const nextPageHtml = `${introHtml}${buildTableHtml(nextRowsHtml)}`;

        if (
          currentRowsHtml &&
          getMeasuredHeight(nextPageHtml) > usablePageHeightPx
        ) {
          const currentIntroHtml = isFirstPage
            ? firstPageIntroHtml
            : continuationIntroHtml;
          pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
          currentRowsHtml = buildRowHtml(item);
          isFirstPage = false;
        } else {
          currentRowsHtml = nextRowsHtml;
        }
      });

      if (currentRowsHtml) {
        const currentIntroHtml = isFirstPage
          ? firstPageIntroHtml
          : continuationIntroHtml;
        pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
      }

      return pages;
    };

    const statementPages = paginateRows(
      statementRows,
      buildStatementRowHtml,
      buildStatementTableHtml,
      headerSectionHtml
    );
    const invoiceLevelPages = paginateRows(
      BalanceRows,
      buildInvoiceLevelRowHtml,
      buildInvoiceLevelTableHtml,
      '',
      ''
    );
    const totalBalancePages = 
paginateRows(
  TotalAccountBalanceRows,
  buildTotalBalanceRowHtml,
  buildTotalBalanceTableHtml,
  '',
  ''
);

    const pageContents: string[] =
      statementPages.length > 0 ? [...statementPages] : [headerSectionHtml];

    invoiceLevelPages.forEach(pageHtml => {
      pageContents.push(pageHtml);
    });

    if (totalBalancePages.length > 0) {
      totalBalancePages.slice(0, -1).forEach(pageHtml => {
        pageContents.push(pageHtml);
      });

      const lastTotalBalancePageHtml =
        totalBalancePages[totalBalancePages.length - 1];
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${lastTotalBalancePageHtml}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(`${lastTotalBalancePageHtml}${messageHtml}`);
      }
    } else {
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(messageHtml);
      }
    }

    pdfContainer = document.createElement('div');
    pdfContainer.style.position = 'fixed';
    pdfContainer.style.left = '-99999px';
    pdfContainer.style.top = '0';
    pdfContainer.style.width = `${pageWidthPx}px`;
    pdfContainer.style.opacity = '0';
    pdfContainer.style.pointerEvents = 'none';
    document.body.appendChild(pdfContainer);

    for (let pageIndex = 0; pageIndex < pageContents.length; pageIndex += 1) {
      pdfContainer.innerHTML = buildPageHtml(pageContents[pageIndex]);
      const pageElement = pdfContainer.firstElementChild as HTMLElement | null;

      if (!pageElement) {
        continue;
      }

      if (pageIndex > 0) {
        pdf.addPage();
      }

      const canvas = await html2canvas(pageElement, {
        scale: 1,
        useCORS: true,
        backgroundColor: '#ffffff'
      });
      const pageImgData = canvas.toDataURL('image/png');
      const imgWidth = pdfWidth;
      const pageImgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(pageImgData, 'PNG', 0, topMargin, imgWidth, pageImgHeight);
      addInvisibleTextLayer(pageElement);
    }

    const pageCount = pdf.getNumberOfPages();
    pdf.setFontSize(9);
    pdf.setTextColor(100);

    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);

      pdf.text(
        `Page ${i} of ${pageCount}`,
        pdf.internal.pageSize.getWidth() - 15,
        10,
        {align: 'right'}
      );
    }
    pdf.save(`Account_Statement_${statementNumber}.pdf`);

    enqueueSnackbar(
      'Account statement downloaded successfully',
      SnackBarConfig.getSuccess()
    );

  } catch (e) {
    console.error('Error fetching PA Statement:', e);
    enqueueSnackbar(getErrorMessage(e), SnackBarConfig.getError());
  } finally {
    if (pdfContainer?.parentNode) {
      pdfContainer.parentNode.removeChild(pdfContainer);
    }
    if (measurementContainer?.parentNode) {
      measurementContainer.parentNode.removeChild(measurementContainer);
    }
    setPaStatementLoading(false);
  }
};

    const printButtonsComponent = (claimType: 'ub-04' | 'hcfa-1500') => {
      const sub = subSectionData?.subSection || {};

      const MAP: {
        'ub-04': {print: string; printText: string; cfg: string; label: string};
        'hcfa-1500': {
          print: string;
          printText: string;
          cfg: string;
          label: string;
        };
      } = {
        'ub-04': {
          print: 'printUB04',
          printText: 'printTextUB04',
          cfg: 'ub_04',
          label: 'UB-04'
        },
        'hcfa-1500': {
          print: 'printHCFA1500',
          printText: 'printTextHCFA1500',
          cfg: 'hcfa_1500',
          label: 'HCFA-1500'
        }
      };

      const meta = MAP[claimType];
      if (!meta) return null;

      const cfg = sub[meta.cfg];

      return (
        <>
          {sub[meta.print] && (
            <LoadingButton
              type="button"
              variant="contained"
              loading={printClaimLoading}
              onClick={() => onPrintButtonClick(claimType, row?.id, cfg)}
              size="small"
              sx={{mr: 2, backgroundColor: theme.palette.primary.dark}}
              startIcon={<Print />}>
              Print
            </LoadingButton>
          )}

          {sub[meta.printText] && (
            <LoadingButton
              type="button"
              variant="contained"
              loading={printTextLoading}
              onClick={() => onPrintTextButtonClick(claimType, row?.id, cfg)}
              size="small"
              sx={{mr: 2, backgroundColor: theme.palette.primary.dark}}
              startIcon={<Print />}>
              Print (text)
            </LoadingButton>
          )}
        </>
      );
    };

    return (
      <DetailPanelContentDiv>
        {subSectionData?.subSection?.previewUB04 ||
        subSectionData?.subSection?.printUB04 ? (
          <Box
            mt={2}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>
            {subSectionData?.subSection?.previewUB04 ? (
              <LoadingButton
                type="button"
                variant="outlined"
                onClick={() =>
                  onPreviewButtonClick(
                    'ub-04',
                    row?.id,
                    subSectionData?.subSection?.ub_04
                  )
                }
                size="small"
                startIcon={<Preview />}
                sx={{
                  mr: 2,
                  backgroundColor: theme.palette.primary.light
                }}>
                Preview
              </LoadingButton>
            ) : null}
            {printButtonsComponent('ub-04')}
          </Box>
        ) : null}
        {subSectionData?.subSection?.previewHCFA1500 ||
        subSectionData?.subSection?.printHCFA1500 ? (
          <Box
            mt={2}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>
            {subSectionData?.subSection?.previewHCFA1500 ? (
              <LoadingButton
                type="button"
                variant="outlined"
                onClick={() =>
                  onPreviewButtonClick(
                    'hcfa-1500',
                    row?.id,
                    subSectionData?.subSection?.hcfa_1500
                  )
                }
                size="small"
                startIcon={<Preview />}
                sx={{
                  mr: 2,
                  backgroundColor: theme.palette.primary.light
                }}>
                Preview
              </LoadingButton>
            ) : null}
            {printButtonsComponent('hcfa-1500')}
          </Box>
        ) : null}
        {generate_statement?
         (
          <Box
            mt={2}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>
            {subSectionData?.subSection?.paStatement ? (
              <LoadingButton
                type="button"
                variant="outlined"
                onClick={() =>
                  onPaButtonClick(
                    'statement',
                    row?.ID || row?.id || row?.AccountID,
                    subSectionData?.subSection
                  )
                }
                loading={paStatementLoading}
                size="small"
                startIcon={<Download />}
                sx={{
                  mr: 2,
                  backgroundColor: theme.palette.primary.light
                }}>
                Account Statement
              </LoadingButton>
            ) : null}
             {subSectionData?.subSection?.mrnStatement ? (
              // <LoadingButton
              //   type="button"
              //   variant="contained"
              //   onClick={() =>
              //     onMrnButtonClick(
              //       'statement',
              //       row?.ID || row?.id || row?.AccountID,
              //       subSectionData?.subSection
              //     )
              //   }
              //   loading={mrnStatementLoading}
              //   size="small"
              //   sx={{mr: 2, backgroundColor: theme.palette.primary.dark}}
              //   startIcon={<Download />}>
              //   Patient Statement
              // </LoadingButton>
              <HighDetailStatement 
                statementType='mrnStatement'
                accountId={row?.ID || row?.id || row?.AccountID}
                subSectionConfig={subSectionData?.subSection}
              />
            ) : null}
          </Box>
        ) : null}
        {subSectionType === FormConstants.DATA_GRID_TYPES.LIST ? (
          renderList(subSectionData?.header, subSectionData?.data || [])
        ) : subSectionType === FormConstants.DATA_GRID_TYPES.DATA_GRID ? (
          <CollapsibleTable
            key={row?.id}
            sectionUIData={getSubSectionData(subSectionData, row)}
            sectionRowsData={[]}
            module={props?.module}
            sub_module={props?.sub_module}
            selectedRowDetails={row}
            searchFormFieldsData={searchFormFieldsData}
          />
        ) : subSectionType === FormConstants.DATA_GRID_TYPES.CARD ? (
          subSectionData?.subSection?.sub_sections?.map?.(
            (item: any, index: number) => {
              return (
                <div key={`${row?.id}-${index}`}>{renderCard(item, row)}</div>
              );
            }
          )
        ) : subSectionType === FormConstants.DATA_GRID_TYPES.TASKCARD ? (
          subSectionData?.subSection?.sub_sections?.map?.(
            (item: any, index: number) => {
              return (
                <div key={`${row?.id}-${index}`}>
                  {renderTaskCard(item, row)}
                </div>
              );
            }
          )
        ) : subSectionType === FormConstants.DATA_GRID_TYPES.TABS ? (
          renderTabs(subSectionData, row)
        ) : subSectionType === FormConstants.DATA_GRID_TYPES.MIXED ? (
          subSectionData?.subSection?.sub_sections?.map((item: any) => {
            return item.type === FormConstants.DATA_GRID_TYPES.CARD ? (
              renderCard(item, row)
            ) : item.type === FormConstants.DATA_GRID_TYPES.DATA_GRID ? (
              <CollapsibleTable
                key={row?.id}
                sectionUIData={item}
                sectionRowsData={[]}
                module={props?.module}
                sub_module={props?.sub_module}
                selectedRowDetails={row}
                searchFormFieldsData={searchFormFieldsData}
              />
            ) : item.type === FormConstants.DATA_GRID_TYPES.TABS ? (
              renderTabs({subSection: item}, row)
            ) : null;
          })
        ) : null}
        {previewClaimFormDialog ? (
          <ClaimViewer
            open={previewClaimFormDialog}
            loading={previewClaimLoading}
            buffer={claimDataBuffer}
            onClose={onClosePreviewClaimFormDialog}
            printable={
              subSectionData?.subSection?.printUB04 ||
              subSectionData?.subSection?.printHCFA1500
                ? true
                : false
            }
            printButtonsComponent={printButtonsComponent}
            claimType={currentClaimType}
          />
        ) : null}
      </DetailPanelContentDiv>
    );
  };

  const getExpandableDetailPanel = React.useCallback(
    (row: any) => <DetailPanelContent subSection={sectionUIData} row={row} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Object.keys(tabsSubSecData)[0], Object.keys(currentTab)[0], sectionUIData]
  );

  const GetSelectedDetails = (ids: any, currentRowsData = rowsData) => {
    const FilteredEncounters = currentRowsData?.filter?.(
      (element: {ID: any}) => {
        return ids?.some?.((item: any) => {
          return item === element.ID;
        });
      }
    );

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const localStorageData = getLocaleStorageData
      ? JSON.parse(getLocaleStorageData)
      : null;

    const finalList = [...selectedData];
    finalList.push(...FilteredEncounters);

    if (getLocaleStorageData) {
      finalList.push(...localStorageData);
    }
    const key = 'ID';
    const uniqueSet = new Set();
    const arrayUniqueByKey: any[] = [];

    finalList.forEach(item => {
      if (!uniqueSet.has(item[key].toString())) {
        arrayUniqueByKey.push(item);
        uniqueSet.add(item[key].toString());
      }
    });

    const FinalRecords = arrayUniqueByKey?.filter?.((element: {ID: any}) => {
      return ids?.some?.((item: any) => {
        return item === element.ID;
      });
    });
    setSelectedData(FinalRecords);
    if (handleCheckBoxClick) handleCheckBoxClick(FinalRecords, ids);
    if (setSelectedReportsData) {
      setSelectedReportsData({
        finrecords: FinalRecords,
        rowsdata: currentRowsData,
        sizevalue: pageizeCount,
        pagesize: totalPagesize,
        perpage: totalPagesizevalue
      });
    }
  };

  const renderDialog = (dialogProps: any): React.ReactElement => {
    return <ActionModalDialog {...dialogProps} />;
  };

  const handleCellClick = async (gridParams: any) => {
    if (gridParams?.value === null) return;
    const id = gridParams?.value?.split(
      FormConstants.FLOWSHEETS_SCREENS.ID_KEY
    )[1];

    // setFlowSheetGridParams(gridParams);

    setOpenDialog(() => ({
      viewDialog: true
    }));
    setDialogLoader(true);

    const cardPayload = {
      sql_data: sectionUIData?.sub_sections?.[0]?.sql_data,
      id,
      LegacyApp: searchFormFieldsData?.legacy_app,
      isBH_selected:
        !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
      isBH_reason: isBHReason,
      application_name: applicationName
    };
    const encryptRequestCardData = EncryptUtils.encryptedData(cardPayload);
    const cardRes = await getPageData(
      applicationName,
      params?.module_name,
      params?.submodule_name,
      {
        tk: encryptRequestCardData
      }
    );
    const [cardConfig, gridConfig] = sectionUIData?.sub_sections || [];

    if (cardRes) {
      setDialogLoader(false);
    }
    setDialogInfo({
      dialogDescription: dialogLoader ? (
        <ComponentLoader />
      ) : (
        <>
          <CardComponent
            module={params?.module_name}
            sub_module={params?.sub_module}
            sectionUIData={{}}
            fields={cardConfig?.fields}
            is_colon_needed={true}
            data={cardRes?.data}
            is_border_required={false}
            component_type="document"
            columns_per_row={1}
          />
        </>
      )
    });
  };

  const renderMainSection = () => {
    return (
      <>
        <DataGridComponent
          gridHeight={props?.gridHeight ?? gridHeight}
          minHeight={props?.minHeight}
          experimentalFeatures={{
            columnGrouping:
              sectionUIData?.columnGrouping === true ? true : false
          }}
          columnGroupingModel={
            sectionUIData?.columnGrouping
              ? sectionUIData?.columnGroupingModel
              : []
          }
          growthChartType={growthChartType}
          expandedRowIds={props?.expandedRowIds || undefined}
          setExpandedRowIds={props?.setExpandedRowIds}
          columns={mainColumns}
          rowHeight={37}
          rows={rowsData}
          rowThreshold={0}
          sectionUIData={sectionUIData}
          searchFormFieldsData={searchFormFieldsData}
          module={props?.module}
          sub_module={props?.sub_module}
          isFromModules={props?.isFromModules}
          selectedRowDetails={props?.selectedRowDetails}
          onRowClick={sectionUIData?.isNotClickable ? null : onRowClick}
          getDetailPanelHeight={getDetailPanelHeight}
          recordId={props?.recordId}
          isEnabled={isEnabled}
          legacyApp={props?.legacyApp}
          ParentLegacyValue={props?.ParentLegacyValue}
          getDetailPanelContent={
            sectionUIData?.expandable
              ? sectionUIData?.renderExpandableComponent
                ? sectionUIData.renderExpandableComponent
                : getExpandableDetailPanel
              : null
          }
          getRowId={(row: any) =>
            row.ID ||
            row.OrderID ||
            row.id ||
            row.PatientID ||
            row.first_name ||
            row.BudgetID ||
            row.Name ||
            row.statId ||
            row.ResultName ||
            row.Priority ||
            row.CodeSystem ||
            row.Priority ||
            row.Date ||
            row.EventCode ||
            row.CreatedDate ||
            row.SubscriberNumber ||
            row.Order ||
            row.PurchaseOrderID ||
            row.RequisitionID ||
            row.InvoiceID ||
            row.InvoiceNumber ||
            row.Sequence ||
            row.EventLevelID ||
            row.VoucherID ||
            row.PaymentID ||
            row.AccountID ||
            row.JournalID ||
            row.Period1 ||
            row.CorporationID ||
            row.ItemID ||
            row.ContractID ||
            row.PayStatus ||
            row.ItemVendorID ||
            row.Year ||
            row.EmpNo ||
            row.DeductionName ||
            row.ProviderName ||
            row.LegacyMRN ||
            row.LegacyApp ||
            Math.random()
          }
          hideFooter={
            props?.forceHideFooter
              ? true
              : props?.hideFooter === false
                ? false
                : (rowsCountData ? rowsCountData : rowsData.length) < 1
          }
          slots={{
            detailPanelExpandIcon: ExpandMoreOutlined,
            detailPanelCollapseIcon: ExpandLessOutlined,
            toolbar:
              props.disableToolbar === true
                ? null
                : params.module_name === FormConstants.MODULE.CLINICAL &&
                    params.submodule_name ===
                      FormConstants.SUB_MODULE.RESULTS &&
                    searchFormFieldsData?.sql_data.tab_name ===
                      'flowsheetsresults'
                  ? null
                  : CustomToolbar,
            pagination: sectionUIData.hasCustomPagination
              ? sectionUIData.renderCustomPagination
              : CustomPagination,
            noRowsOverlay: () => (
              <EmptyContent
                sx={{
                  py: 10
                }}
                title="No Data"
              />
            ),
            noResultsOverlay: () => (
              <EmptyContent
                sx={{
                  py: 10
                }}
                title="No results found"
              />
            )
          }}
          rowsCountData={rowsCountData}
          paginationMode="server"
          sortingMode={props?.module === 'patient-accounting' ? 'client' : 'server'}
          sortingOrder={['desc', 'asc']}
          pageSize={environment?.defaultRowsLimit}
          rowsPerPageOptions={environment?.rowsPerPageOptions}
          checkboxSelection={sectionUIData.is_selection_needed ? true : false}
          handleDisableCheckBox={handleDisableCheckBox}
          rowsCount={rowsCount}
          tableRefresh={props?.tableRefresh}
          setTableRefresh={props?.setTableRefresh}
          handleOnSelectionModelChange={(data: any) => {
            if (props?.handleOnSelectionModelChange) {
              props.handleOnSelectionModelChange(data);
            }
            GetSelectedDetails(data.ids, data.data);
          }}
          selectedCheckboxColumns={
            clearSelectedDataCount > 0
              ? selectedRowIds
              : getLocaleStorageData.length > 0
                ? selectedRowIds
                : []
          }
          setRowsCountData={setRowsCountData}
          setRowsPAData={setRowsPAData}
          BenefitsPayload={BenefitsPayload}
          isReportsButtonLoader={isReportsButtonLoader}
          // onCellClick={onCellClick}
          onCellClick={(gridParams: any) => {
            if (
              params.module_name === FormConstants.MODULE.CLINICAL &&
              params.submodule_name === FormConstants.SUB_MODULE.RESULTS &&
              sectionUIData?.sql_data?.tab_name === 'flowsheetsresults'
            ) {
              handleCellClick(gridParams);
            } else if (onCellClick) {
              onCellClick(gridParams);
            }
          }}
          loading={props?.loading}
          procedure_type={procedure_type}
          accession_number={accession_number}
          specimen_number_id={specimen_number_id}
          specimen_number={specimen_number}
          procedure_id={procedure_id}
          demographic_id={props?.demographic_id}
          limited={limit}
          offseted={offset}
          openning={opening}
          refreshFilter={props.refreshFilter}
          setRefreshFilter={props.setRefreshFilter}
          setopening={setopening}
          deleteDocument={deleteDocument}
          setDeleteDocument={setDeleteDocument}
          onDataReceiveForGridSearch={handleDataForCustomToolbar}
          onSortModelChange={props?.onSortModelChange}
          onGridFiltersChange={props?.onGridFiltersChange}
          isRowSelectable={props?.isRowSelectable}
          rowCount={props?.rowCount || 0}
          onPaginationModelChange={props?.onPaginationModelChange}
          displayHorizontalScroll={
            props?.displayHorizontalScroll ||
            sectionUIData?.displayHorizontalScroll
          }
          sx={props?.sx || {}}
          checkboxColor={props?.checkboxColor || ''}
          processRowUpdate={props?.processRowUpdate}
          pinnedRowsData={pinnedRowsData}
          setSyncUsers={setSyncUsers}
          usersync={usersync}
        />

        <Dialog
          open={showDialog}
          onClose={() => {
            setShowDialogOpen(false);
            setActiveAction(null);
          }}>
          <DialogTitle>Export</DialogTitle>

          <DialogContent>
            <Typography sx={{mb: 3}}>
              {`Only the first ${environment.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT || 5000} rows will be included in the exported file.`}
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                setShowDialogOpen(false);
                setActiveAction(null);
              }}
              variant="outlined"
              color="inherit">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setShowDialogOpen(false);
                if (activeAction == 'excel') {
                  handleExport();
                } else if (activeAction === 'csv') {
                  handleCSV();
                }else if (activeAction === 'pdf') {
                  handlePDF();
                }
                setActiveAction(null);
              }}
              variant="contained">
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return (
    <>
      {sectionUIData?.columnGrouping ? (
        <ColumnDataGridComponentDiv>
          {mainColumns?.length ? renderMainSection() : null}
        </ColumnDataGridComponentDiv>
      ) : props.module === FormConstants.MODULE.PURGE_AND_LEGAL_HOLD ||
        props.module === FormConstants.MODULE.USER_ACCESS ? (
        <RenderMainSectionDiv>
          {mainColumns?.length ? renderMainSection() : null}
        </RenderMainSectionDiv>
      ) : mainColumns?.length ? (
        renderMainSection()
      ) : null}

      {renderDialog({
        title: `${t('PRIVATE.FLOWSHEET.TITLE', {
          ns: 'private'
        })}`,
        open: openDialog.viewDialog,
        onClose: dialogClose,
        description: dialogInfo?.dialogDescription,
        handleCloseBtnClick: dialogClose,
        flowSheetScreen: true,
        isVitalDataGrid: false,
        reportsLoader: dialogLoader,
        noLabelText: `${t('PRIVATE.FLOWSHEET.CLOSE', {
          ns: 'private'
        })}`
      })}
    </>
  );
};

export default CollapsibleTable;

